const enTranslations: Record<string, string> = {
  "app_title": "DriverFlow CRM",
  "brand_subtitle": "Recruiting CRM",
  "skip_to_content": "Skip to main content",
  "nav_platform": "Platform",
  "nav_workspace": "Workspace",
  "nav_operations": "Operations",
  "nav_management": "Management",
  "nav_administration": "Administration",
  "nav_audit_log": "Audit log",
  "nav_dashboard": "Dashboard",
  "nav_vacancies": "Vacancies",
  "nav_candidates": "Candidates",
  "nav_hiring_pipeline": "Hiring pipeline",
  "nav_interviews": "Interviews",
  "nav_tasks": "Tasks",
  "nav_documents": "Documents",
  "nav_reports": "Reports",
  "nav_employees": "Employees",
  "nav_company": "Company",
  "nav_settings": "Settings",
  "btn_sign_out": "Sign out",
  "btn_sign_in": "Sign in",
  "btn_apply": "Apply",
  "btn_clear": "Clear",
  "btn_save": "Save",
  "btn_cancel": "Cancel",
  "btn_create": "Create",
  "btn_update": "Update",
  "btn_delete": "Delete",
  "btn_edit": "Edit",
  "btn_export_csv": "Export CSV",
  "btn_save_filter": "Save filter",
  "btn_go_back": "Go back",
  "btn_undo": "Undo",
  "kanban_drop_here": "Drop here",
  "kanban_drag_candidate": "Drag {name}",
  "kanban_move_candidate": "Move {name}",
  "kanban_move_here": "Move here",
  "kanban_release_here": "Release here",
  "kanban_release_to_stage": "Release to move to {stage}",
  "kanban_empty_stage": "No candidates at this stage",
  "spa_search": "Search",
  "public_requirements_title": "What we require",
  "public_req_cdl": "Valid CDL",
  "public_req_experience": "At least {months} months of driving experience",
  "public_req_accidents": "No more than {count} accident(s) in the last 3 years",
  "public_req_violations": "No more than {count} moving violation(s)",
  "public_req_medical": "Valid DOT medical card",
  "public_medical_card_expiry": "Medical card valid until",
  "public_medical_card_expiry_hint": "The date printed on your DOT medical examiner's certificate.",
  "public_medical_card_expiry_required": "Enter the medical card expiry date",
  "public_endorsements_required_fmt": "required: {list}",
  "public_field_required": "Please fill this in",
  "public_answer_required": "Please answer this question",
  "public_select_cdl_class": "Choose your licence class",
  "public_select_cdl_state": "Choose the issuing state",
  "public_select_experience": "Choose how long you have been driving",
  "public_select_home_state": "Choose your home state",
  "public_continue_application": "Continue where you left off",
  "public_start_over": "Start a new application",
  "public_draft_restored": "We restored your unfinished application.",
  "public_draft_saved": "Saved on this device",
  "public_already_applied": "Your application has already been received.",
  "public_applied_reference": "Application #{reference}",
  "public_consent_label": "I agree that the recruiting team may contact me about this application.",
  "public_draft_restored_files_lost": "Your answers are saved. Please choose your documents again, or add them later.",
  "public_start_over_confirm": "Start a new application? This will clear your saved answers.",
  "public_vacancy_load_failed": "We couldn’t load this opportunity. Please check your connection and try again.",
  "public_draft_saving": "Saving\u2026",
  "public_go_to_step": "Go to step {step}",
  "public_documents_hint": "Optional \u2014 you can also send them later.",
  "public_remove_file": "Remove file",
  "public_file_too_large": "This file is larger than 10 MB",
  "public_file_type_invalid": "Use a photo or a PDF",
  "public_documents_uploading": "Sending your documents\u2026",
  "public_documents_upload_failed": "We could not attach your documents, but your application was received. The recruiter will ask for them.",
  "public_progress_label": "Application progress",
  "api_upload_link_expired": "This upload link has expired",
  "api_upload_limit_reached": "No more files can be attached to this application",
  "api_document_type_invalid": "Unsupported document type",
  "document_uploaded_by_applicant": "Applicant",

  "nav_hiring": "Hiring",
  "metric_open_positions": "Drivers still needed",
  "spa_months_short": "{months} mo",
  "hiring_heading": "Driver hiring",
  "hiring_description": "One set of criteria, one application form, one link to share.",
  "hiring_tab_criteria": "Criteria",
  "hiring_tab_form": "Application",
  "hiring_tab_link": "Application link",
  "hiring_tab_applications": "Applications",
  "hiring_criteria_title": "Who we hire",
  "hiring_criteria_hint": "Applicants are screened against these rules automatically. This is the only place criteria are set.",
  "hiring_cdl_required": "CDL required",
  "hiring_cdl_class": "CDL class",
  "hiring_cdl_any": "Any class",
  "hiring_min_experience": "Minimum experience, months",
  "hiring_max_accidents": "Accidents allowed, max",
  "hiring_max_violations": "Violations allowed, max",
  "hiring_medical_required": "Medical card required",
  "hiring_endorsements": "Required endorsements",
  "hiring_allowed_states": "Hiring states",
  "hiring_states_any": "All states",
  "hiring_preview_title": "How this reads to a driver",
  "hiring_link_title": "Application link",
  "hiring_link_hint": "Send this link to drivers. Every submission lands in Applications.",
  "hiring_link_open": "Accepting applications",
  "hiring_link_paused": "Paused — the page collects a waitlist instead",
  "hiring_copy_link": "Copy link",
  "hiring_open_link": "Open",
  "hiring_channels_title": "Channels",
  "hiring_channels_hint": "A separate link per channel shows which source actually delivers hires.",
  "hiring_channel_name": "Channel name",
  "hiring_add_channel": "Add channel",
  "hiring_th_channel": "Channel",
  "hiring_th_visits": "Visits",
  "hiring_th_starts": "Started",
  "hiring_th_submissions": "Submitted",
  "hiring_th_conversion": "Conversion",
  "hiring_th_cost": "Cost per application",
  "hiring_stat_views": "Page views",
  "hiring_stat_starts": "Started the form",
  "hiring_stat_submissions": "Submitted",
  "hiring_stat_hired": "Hired",
  "hiring_form_title": "Application form",
  "hiring_form_hint": "Fewer questions means more completed applications. Everything else can be asked later.",
  "hiring_profile_title": "What the driver sees",
  "hiring_legacy_title": "Older postings found",
  "hiring_legacy_body": "{count} posting(s) with {candidates} candidate(s) still exist from the multi-vacancy model. Move them here to keep one funnel.",
  "hiring_legacy_action": "Move to this profile",
  "hiring_merged": "Candidates moved",
  "hiring_saved": "Hiring profile saved",
  "hiring_criteria_saved": "Criteria saved",
  "hiring_position_title": "Position title",
  "hiring_drivers_required": "Drivers needed",
  "hiring_applications_hint": "Every submission from the link, newest first, screened against your criteria.",
  "hiring_screening_pass": "Meets criteria",
  "hiring_screening_fail": "Does not meet criteria",
  "hiring_screening_review": "Needs review",
  "hiring_no_applications": "No applications yet",
  "hiring_no_applications_hint": "Share the link to start receiving them.",

  "interviews_edit_title": "Edit interview",
  "candidate_city": "City",
  "candidate_edit_description": "Contacts, licence details and assignment. Changes are recorded in the audit log.",
  "candidate_open_profile_hint": "Profile completeness",
  "candidate_gaps_title": "Missing for a complete profile",
  "candidate_gaps_none": "All key fields are filled in",
  "candidate_call": "Call",
  "candidate_email_action": "Email",
  "candidate_copy": "Copy",
  "candidate_stage_moved": "Stage changed",

  "btn_confirm": "Confirm",
  "btn_back_to_list": "Back to list",
  "toast_region_label": "Notifications",
  "toast_stage_changed": "Stage changed",
  "toast_stage_changed_detail": "{name} → {stage}",
  "toast_stage_reverted": "Stage restored",
  "toast_task_status_changed": "Task status updated",
  "toast_task_completed": "Task completed",
  "toast_document_reviewed": "Document status updated",
  "toast_candidate_created": "Candidate added",
  "toast_task_created": "Task created",
  "toast_interview_created": "Interview scheduled",
  "toast_interview_updated": "Interview updated",
  "toast_document_uploaded": "Document uploaded",
  "toast_note_added": "Note added",
  "toast_candidate_updated": "Profile saved",
  "toast_qualification_recalculated": "Qualification recalculated",
  "toast_filter_saved": "View saved",
  "toast_filter_removed": "View removed",
  "toast_copied": "Copied to clipboard",
  "toast_failed": "Action failed",
  "confirm_reject_document_title": "Reject this document?",
  "confirm_reject_document_body": "The candidate's compliance status will change and the recruiter will need to request a new upload.",
  "confirm_cancel_task_title": "Cancel this task?",
  "confirm_cancel_task_body": "The task stays in history but no longer counts towards workload.",
  "theme_appearance": "Appearance",
  "theme_light": "Light",
  "theme_dark": "Dark",
  "theme_system": "System",
  "filters_active": "Active filters",
  "filters_clear_all": "Clear all",
  "filters_saved_views": "Saved views",
  "filters_save_current": "Save current view",
  "filters_view_name": "View name",
  "results_found": "{count} of {total}",
  "pagination_page_of": "Page {page} of {pages}",
  "pagination_previous": "Previous",
  "pagination_next": "Next",
  "sort_by": "Sort by {column}",
  "not_found_title": "Page not found",
  "not_found_body": "The link may be outdated, or the record was removed.",
  "command_placeholder": "Search candidates or jump to a page…",
  "command_pages": "Pages",
  "command_candidates": "Candidates",
  "command_no_results": "Nothing found",
  "command_hint_open": "to open",
  "command_hint_close": "to close",
  "stage_change_label": "Hiring stage",
  "quick_actions": "Quick actions",
  "search_placeholder": "Search candidates, phone, CDL…",
  "role_system_admin": "Administrator",
  "role_admin": "Administrator",
  "role_company_admin": "Administrator",
  "role_recruiter": "Recruiter",
  "role_document_specialist": "Document Specialist",
  "role_observer": "Observer",
  "employee_add_description": "Create the account and choose what this person may do. A password is generated automatically.",
  "employee_group_recruiting": "Candidates and vacancies",
  "employee_group_recruiting_hint": "Work the pipeline: vacancies, candidates, interviews, tasks, screening and hiring decisions.",
  "employee_group_documents": "Documents and compliance",
  "employee_group_documents_hint": "Review uploaded documents and run compliance checks.",
  "employee_group_reports": "Reports",
  "employee_group_reports_hint": "Open reports and download CSV exports.",
  "employee_group_settings": "Company settings",
  "employee_group_settings_hint": "Change pipeline stages and screening rules for the whole workspace.",
  "employee_group_team": "Employees and access",
  "employee_group_team_hint": "Add employees and change what everybody else may do. Grant with care.",
  "employee_access_level": "Access level",
  "employee_access_level_hint": "A ready-made set of permissions. Pick one, then adjust the switches below if needed.",
  "employee_access_level_locked": "This account's access level is managed outside this screen.",
  "employee_position_hint": "Free text for the org chart — it does not affect access.",
  "employee_status_label": "Account status",
  "employees_edit_title": "Edit employee",
  "employee_self_role_locked": "You cannot change your own access level.",
  "employee_terminal_hint": "The base the employee is assigned to.",
  "employee_password_heading": "Employee created",
  "employee_password_reset_heading": "New password issued",
  "employee_password_generated_hint": "Hand these over to the employee. The password is shown once and cannot be recovered afterwards — only reset.",
  "employee_password_login": "Sign-in email",
  "employee_password_value": "Password",
  "employee_password_copy": "Copy password",
  "employee_reset_password": "Issue a new password",
  "employee_reset_password_hint": "Replaces the current password and signs the employee out of every device.",
  "employee_edit_password_hint": "Leave blank to keep current password. Use at least 8 characters.",
  "employee_created_toast": "Employee created",
  "employee_edit_description": "Update the account details and what this person may do.",
  "employee_permissions": "Access permissions",
  "employee_permissions_hint": "The access level sets these for you. Adjust them here if this person needs something different.",
  "employee_permissions_hint_create": "Select the sections and permissions this employee will have access to.",
  "btn_archive": "Archive",
  "btn_unarchive": "Restore",
  "employee_archive_confirm_title": "Archive employee?",
  "employee_archive_confirm_body": "The employee {name} will be archived and will not be able to sign in. Historical records and activity will be kept.",
  "employee_unarchive_confirm_title": "Restore employee?",
  "employee_unarchive_confirm_body": "The employee {name} will be restored to active status.",
  "employee_delete_confirm_title": "Delete employee?",
  "employee_delete_confirm_body": "Are you sure you want to permanently delete employee {name}? This action cannot be undone.",
  "employee_archived_toast": "Employee archived",
  "employee_unarchived_toast": "Employee restored",
  "employee_deleted_toast": "Employee deleted",
  "employee_cannot_archive_self": "You cannot archive your own account",
  "employee_cannot_delete_self": "You cannot delete your own account",
  "employee_empty_description": "Add the first employee and choose what they can do in the workspace.",
  "employees_actions": "Actions",
  "company_edit_global_only": "Editable by global admin only",
  "company_edit_admin_description": "Only the global administrator can update company details.",
  "profile_personal_details": "Personal details",
  "profile_personal_details_hint": "Update your name, email address and phone number.",
  "profile_saved": "Account details updated.",
  "profile_passwords_must_match": "The new passwords must match.",
  "spa_not_assigned": "Not assigned",
  "permission_view": "View workspace",
  "permission_manage_users": "Manage employees",
  "permission_manage_vacancies": "Manage vacancies",
  "permission_manage_candidates": "Manage candidates",
  "permission_manage_stages": "Manage pipeline stages",
  "permission_manage_interviews": "Manage interviews",
  "permission_manage_tasks": "Manage tasks",
  "permission_manage_documents": "Review documents",
  "permission_view_reports": "View reports and exports",
  "permission_manage_settings": "Manage workspace settings",
  "permission_qualify": "Qualify candidates",
  "permission_decision": "Make hiring decisions",
  "permission_compliance": "Manage compliance checks",
  "permission_upload_documents": "Upload documents",
  "api_email_in_use": "This email address is already in use",
  "api_terminal_not_found": "The selected terminal does not belong to this company",
  "api_cannot_grant_permission": "You cannot grant a permission that you do not have",
  "api_cannot_change_own_access": "You cannot remove your own administrator access or block your own account",
  "status_draft": "Draft",
  "status_active": "Active",
  "status_paused": "Paused",
  "status_closed": "Closed",
  "status_archived": "Archived",
  "status_new": "New",
  "status_in_progress": "In Progress",
  "status_completed": "Completed",
  "status_cancelled": "Cancelled",
  "status_overdue": "Overdue",
  "status_scheduled": "Scheduled",
  "status_rescheduled": "Rescheduled",
  "status_no_show": "No Show",
  "status_uploaded": "Uploaded",
  "status_under_review": "Under Review",
  "status_approved": "Approved",
  "status_rejected": "Rejected",
  "status_missing": "Missing",
  "status_expiring_soon": "Expiring Soon",
  "status_expired": "Expired",
  "status_not_started": "Not Started",
  "status_not_required": "Not Required",
  "status_failed": "Failed",
  "status_hired": "Hired",
  "status_withdrawn": "Withdrawn",
  "status_blocked": "Blocked",
  "stage_new": "New",
  "stage_contacted": "Contacted",
  "stage_prequalification": "Prequalification",
  "stage_qualified": "Qualified",
  "stage_interview_scheduled": "Interview Scheduled",
  "stage_interview_completed": "Interview Completed",
  "stage_application": "Application",
  "stage_document_review": "Document Review",
  "stage_approved": "Approved",
  "stage_hired": "Hired",
  "stage_rejected": "Rejected",
  "stage_withdrawn": "Withdrawn",
  "stage_archived": "Archived",
  "offer_score_pay": "Pay",
  "offer_score_home_time": "Home time",
  "offer_score_experience": "Experience",
  "offer_score_benefits": "Benefits",
  "offer_score_requirements": "Requirements",
  "offer_score_equipment": "Equipment",
  "offer_score_bonuses": "Bonuses",
  "source_referral": "Referral",
  "source_website": "Website",
  "source_job_board": "Job board",
  "source_walk_in": "Walk-in",
  "source_social_media": "Social media",
  "source_other": "Other",
  "task_category_contact_candidate": "Contact candidate",
  "task_category_conduct_interview": "Conduct interview",
  "task_category_review_document": "Review document",
  "task_category_request_information": "Request information",
  "task_category_make_decision": "Make decision",
  "task_category_other": "Other",
  "document_type_medical_card": "Medical Card",
  "document_type_passport": "Passport",
  "document_type_social_security": "Social Security",
  "document_type_driver_application": "Driver Application",
  "document_type_background_check": "Background Check",
  "document_type_drug_screening": "Drug Screening",
  "document_type_certificate": "Certificate",
  "document_type_other": "Other",
  "compliance_item_application_complete": "Application completed",
  "compliance_item_cdl_uploaded": "CDL uploaded",
  "compliance_item_cdl_valid": "CDL is valid",
  "compliance_item_medical_uploaded": "Medical Card uploaded",
  "compliance_item_medical_valid": "Medical Card is valid",
  "compliance_item_employment_history": "Employment history completed",
  "compliance_item_mvr_uploaded": "MVR uploaded",
  "compliance_item_psp_uploaded": "PSP uploaded",
  "compliance_item_fmcsa_checked": "FMCSA check added",
  "compliance_item_voe_completed": "VOE completed",
  "compliance_item_background_check": "Background check added",
  "compliance_item_drug_screening": "Drug screening added",
  "compliance_item_documents_verified": "Documents verified",
  "compliance_item_final_decision": "Final decision made",
  "qualification_qualified": "Qualified",
  "qualification_potentially_qualified": "Potentially Qualified",
  "qualification_manual_review": "Manual Review",
  "qualification_disqualified": "Disqualified",
  "qualification_incomplete": "Incomplete",
  "unassigned": "Unassigned",
  "unknown": "Unknown",
  "no_vacancy": "No vacancy",
  "unknown_vacancy": "Unknown vacancy",
  "no_stage": "No stage",
  "unknown_stage": "Unknown stage",
  "no_description": "No description provided.",
  "no_contact_details": "No contact details",
  "no_phone": "No phone",
  "no_terminal": "No terminal",
  "no_address": "No address",
  "error_record_not_found": "Record not found",
  "error_invalid_credentials": "Invalid email or password.",
  "error_company_blocked": "Your company account is blocked.",
  "error_reset_link_invalid": "The reset link is invalid or expired",
  "error_passwords_mismatch": "Passwords must match and contain at least 8 characters.",
  "error_vacancy_title_required": "Vacancy title is required",
  "error_invalid_vacancy_status": "Invalid vacancy status",
  "error_filter_name_required": "Filter name is required",
  "error_names_required": "First and last name are required",
  "error_note_empty": "Note cannot be empty",
  "error_employer_required": "Employer is required",
  "error_invalid_document_status": "Invalid document status",
  "error_checklist_item_not_found": "Checklist item not found",
  "error_invalid_checklist_status": "Invalid checklist status",
  "error_interview_datetime_required": "Interview date and time are required",
  "error_task_deadline_required": "Task deadline is required",
  "error_task_title_required": "Task title is required",
  "error_observer_readonly": "Observer access is read-only",
  "error_invalid_task_status": "Invalid task status",
  "error_unsupported_file_type": "Unsupported file type",
  "error_file_too_large": "File is larger than 20 MB",
  "error_insufficient_permissions": "Insufficient permissions",
  "error_document_not_found": "Document not found",
  "error_email_in_use": "Email is already in use",
  "error_password_min_length": "Password must contain at least 8 characters",
  "error_terminal_name_required": "Terminal name is required",
  "error_notification_not_found": "Notification not found",
  "error_stage_name_required": "Stage name is required",
  "error_cannot_delete_stage": "Cannot delete a stage that contains candidates",
  "error_admin_access_required": "System administrator access required",
  "error_company_name_required": "Company name is required",
  "error_company_already_exists": "Company already exists",
  "error_company_not_found": "Company not found",
  "error_email_already_exists": "Email already exists",
  "error_export_not_found": "Export not found",
  "error_version_not_found": "Version not found",
  "error_file_not_found": "File not found",
  "error_comment_required_manual": "A comment is required for a manual qualification decision",
  "error_comment_required": "A comment is required",
  "error_current_password_incorrect": "Current password is incorrect.",
  "error_new_passwords_mismatch": "New passwords must match and contain at least 8 characters.",
  "flash_password_updated": "Password updated",
  "flash_vacancy_created": "Vacancy created",
  "flash_vacancy_updated": "Vacancy updated",
  "flash_vacancy_copied": "Vacancy copied",
  "flash_status_updated": "Status updated",
  "flash_filter_saved": "Filter saved",
  "flash_candidate_created": "Candidate created",
  "flash_candidate_updated": "Candidate updated",
  "flash_note_added": "Note added",
  "flash_employment_added": "Employment history added",
  "flash_incident_added": "Incident added",
  "flash_interview_scheduled": "Interview scheduled",
  "flash_interview_updated": "Interview updated",
  "flash_task_created": "Task created",
  "flash_task_updated": "Task updated",
  "flash_document_uploaded": "Document uploaded",
  "flash_document_reviewed": "Document reviewed",
  "flash_company_updated": "Company updated",
  "flash_terminal_created": "Terminal created",
  "flash_notifications_read_all": "All notifications marked as read",
  "flash_rules_updated": "Rules updated",
  "flash_stage_created": "Stage created",
  "flash_stage_updated": "Stage updated",
  "flash_stage_deleted": "Stage deleted",
  "flash_company_created": "Company created",
  "flash_company_status_updated": "Company status updated",
  "flash_user_created": "User created",
  "flash_employee_created": "Employee created",
  "flash_employee_updated": "Employee updated",
  "flash_qualification_saved": "Qualification saved",
  "flash_risk_decision_saved": "Risk decision saved",
  "flash_checklist_updated": "Checklist updated",
  "notif_new_candidate_assigned": "New candidate assigned",
  "notif_candidate_stage_changed": "Candidate stage changed",
  "notif_manual_review_required": "Manual qualification review required",
  "notif_interview_scheduled": "Interview scheduled",
  "notif_task_assigned": "Task assigned",
  "notif_document_uploaded": "New document uploaded",
  "page_login": "Sign in · DriverFlow",
  "page_forgot_password": "Reset password · DriverFlow",
  "page_reset_password": "Choose password · DriverFlow",
  "page_dashboard": "Dashboard · DriverFlow",
  "page_candidates": "Candidates · DriverFlow",
  "page_candidate_detail": "{name} · DriverFlow",
  "page_vacancies": "Vacancies · DriverFlow",
  "page_vacancy_detail": "{name} · DriverFlow",
  "page_kanban": "Hiring pipeline · DriverFlow",
  "page_interviews": "Interviews · DriverFlow",
  "page_tasks": "Tasks · DriverFlow",
  "page_documents": "Documents · DriverFlow",
  "page_reports": "Reports · DriverFlow",
  "page_employees": "Employees · DriverFlow",
  "page_company": "Company · DriverFlow",
  "page_settings": "Settings · DriverFlow",
  "page_notifications": "Notifications · DriverFlow",
  "page_audit": "Audit log · DriverFlow",
  "page_profile": "My profile · DriverFlow",
  "page_admin": "System administration · DriverFlow",
  "page_admin_company": "{name} · System administration",
  "page_document_versions": "Document versions · DriverFlow",
  "login_welcome": "Welcome back",
  "login_description": "Manage driver recruiting, documents and compliance in one secure workspace.",
  "login_email_label": "Email address",
  "login_password_label": "Password",
  "login_forgot_password": "Forgot password?",
  "settings_stage_rename": "Stage name",
  "settings_stage_shown_as": "shown as",
  "settings_stage_move_up": "Move up",
  "settings_stage_move_down": "Move down",
  "settings_stage_saved": "Stage updated",
  "settings_stage_order_saved": "Order saved",
  "settings_stage_deleted": "Stage deleted",
  "settings_stage_delete_title": "Delete this stage?",
  "settings_stage_delete_body": "Candidates already on this stage keep their history. A stage that is still in use cannot be deleted.",
  "settings_stage_reorder_hint": "Drag a stage, or use the arrows, to change the order candidates move through.",
  "notifications_mark_all_read": "Mark all as read",
  "notifications_all_read": "All notifications marked as read",
  "employment_add": "Add employer",
  "employment_add_title": "Previous employer",
  "employment_employer": "Employer",
  "employment_position": "Position",
  "employment_start": "From",
  "employment_end": "To",
  "employment_reason": "Reason for leaving",
  "employment_routes": "Route types",
  "employment_equipment": "Equipment",
  "employment_added": "Employer added",
  "employment_end_before_start": "The end date cannot be earlier than the start date",
  "calendar_previous_month": "Previous month",
  "calendar_next_month": "Next month",
  "calendar_today": "Today",
  "forgot_heading": "Reset your password",
  "forgot_description": "Enter the address you sign in with and we will send a reset link.",
  "forgot_submit": "Send reset link",
  "forgot_sent_heading": "Check your email",
  "forgot_sent_body": "If an account exists for {email}, a reset link is on its way. The link is valid for one hour.",
  "forgot_dev_token": "Development mode: open the reset link directly.",
  "reset_heading": "Choose a new password",
  "reset_description": "Pick something you have not used before. At least 8 characters.",
  "reset_submit": "Save new password",
  "reset_done_heading": "Password updated",
  "reset_done_body": "You can sign in with your new password now.",
  "back_to_sign_in": "Back to sign in",
  "login_demo_access": "Demo access",
  "login_marketing_heading": "From first contact to hired driver.",
  "login_marketing_description": "A focused recruiting operating system for transportation teams.",
  "login_visual_pipeline": "Driver hiring pipeline",
  "login_visual_workspace": "Recruiting command center",
  "login_visual_live": "Live workflow",
  "login_visual_stage_new": "New lead",
  "login_visual_stage_qualified": "Qualified",
  "login_visual_stage_interview": "Interview",
  "login_visual_stage_hired": "Hired",
  "login_visual_candidates": "Candidate progress",
  "login_visual_candidate_ready": "Ready for interview",
  "login_visual_candidate_review": "Documents in review",
  "login_visual_activity": "Recent activity",
  "login_visual_documents_verified": "Documents verified",
  "login_visual_compliance_clear": "Compliance clear",
  "login_visual_interview_scheduled": "Interview scheduled",
  "login_visual_updated_now": "Updated just now",
  "forgot_password_heading": "Reset your password",
  "forgot_password_description": "Enter your account email. This standalone edition creates a one-time reset link inside the system.",
  "forgot_password_success": "If an active account was found, a reset link was created.",
  "forgot_password_open_link": "Open secure reset link",
  "forgot_password_create_link": "Create reset link",
  "forgot_password_back": "Back to sign in",
  "reset_password_heading": "Choose a new password",
  "reset_password_description": "Use at least eight characters.",
  "error_page_heading": "Something needs attention",
  "dashboard_heading": "Recruiting dashboard",
  "dashboard_description": "Live operating view across your vacancies, candidates and compliance workload.",
  "dashboard_period_7": "Last 7 days",
  "dashboard_period_30": "Last 30 days",
  "dashboard_period_90": "Last 90 days",
  "dashboard_add_candidate": "Add candidate",
  "metric_active_vacancies": "Active vacancies",
  "metric_total_candidates": "Total candidates",
  "metric_new_candidates": "New candidates",
  "metric_qualified": "Qualified",
  "metric_scheduled_interviews": "Scheduled interviews",
  "metric_document_review": "Document review",
  "metric_hired": "Hired",
  "metric_rejected": "Rejected",
  "metric_expiring_documents": "Expiring documents",
  "dashboard_funnel_heading": "Hiring funnel",
  "dashboard_funnel_description": "Candidate distribution across configured stages",
  "dashboard_funnel_open": "Open pipeline",
  "dashboard_recent_heading": "Recently added candidates",
  "dashboard_recent_description": "Latest profiles in the database",
  "dashboard_recent_view_all": "View all",
  "dashboard_interviews_heading": "Upcoming interviews",
  "dashboard_interviews_description": "Next scheduled conversations",
  "dashboard_interviews_calendar": "Calendar",
  "dashboard_needs_heading": "Needs attention",
  "dashboard_needs_description": "Overdue work and expiring records",
  "dashboard_overdue": "Overdue",
  "empty_no_candidates": "No candidates yet",
  "empty_add_first_candidate": "Add your first candidate to begin.",
  "empty_no_upcoming_interviews": "No upcoming interviews",
  "empty_schedule_from_profile": "Schedule one from a candidate profile.",
  "empty_everything_on_track": "Everything is on track",
  "empty_no_urgent_tasks": "No urgent tasks or documents.",
  "candidates_heading": "Candidates",
  "candidates_description": "Search, qualify and manage every driver profile in your company database.",
  "candidates_add": "Add candidate",
  "candidates_filters": "Filters",
  "candidates_scroll_hint": "Swipe horizontally to see all columns",
  "table_scroll_hint": "Scroll the table sideways to see the remaining columns",
  "candidates_all_stages": "All stages",
  "candidates_all_vacancies": "All vacancies",
  "candidates_all_recruiters": "All recruiters",
  "candidates_all_states": "All states",
  "candidates_all_qualification": "All qualification",
  "candidates_all_compliance": "All compliance",
  "candidates_expiring_docs": "Expiring docs",
  "candidates_th_candidate": "Candidate",
  "candidates_th_vacancy": "Vacancy",
  "candidates_th_stage": "Stage",
  "candidates_th_recruiter": "Recruiter",
  "candidates_th_qualification": "Qualification",
  "candidates_th_risk": "Risk",
  "candidates_th_compliance": "Compliance",
  "candidates_th_added": "Added",
  "candidates_save_filter_heading": "Save current filter",
  "candidates_filter_name": "Filter name",
  "candidates_filter_placeholder": "e.g. Qualified OTR candidates",
  "candidates_saved": "Saved:",
  "candidates_placeholder": "Name, phone, email, CDL…",
  "empty_no_candidates_match": "No candidates match these filters",
  "empty_clear_or_add": "Clear filters or add a new candidate.",
  "campaigns_heading": "Vacancies",
  "campaigns_description": "Set hiring goals, manage acquisition channels and move every vacancy to a measurable result.",
  "campaigns_summary": "Vacancy portfolio summary",
  "campaigns_active": "Active vacancies",
  "campaigns_open_roles": "Drivers remaining",
  "campaigns_in_pipeline": "Active pipeline",
  "campaigns_hired": "Hired",
  "campaign_new": "New vacancy",
  "campaign_name": "Vacancy title",
  "campaign_name_placeholder": "e.g. Regional Reefer — Chicago",
  "campaign_progress": "Hiring progress",
  "campaign_pipeline": "Pipeline",
  "campaign_active_candidates": "Active candidates",
  "campaign_target_date": "Target date",
  "campaign_open_workspace": "Open campaign workspace",
  "campaign_hiring_goal": "Hiring goal",
  "campaign_of": "of",
  "campaign_total_applications": "total applications",
  "campaign_time_to_hire": "Time to hire",
  "campaign_days": "days",
  "campaign_average": "campaign average",
  "campaign_budget_used": "Budget used",
  "campaign_of_budget": "of",
  "campaign_budget_not_set": "Budget not set",
  "campaign_copy_public_link": "Copy public link",
  "campaign_copied": "Copied",
  "campaign_pause": "Pause",
  "campaign_resume": "Resume",
  "campaign_publish": "Publish",
  "campaign_close": "Close",
  "campaign_sources": "Sources",
  "campaign_application_form": "Application form",
  "campaign_analytics": "Analytics",
  "campaign_plan_progress": "Hiring plan",
  "campaign_plan_progress_hint": "Progress against the driver target for this campaign.",
  "campaign_complete": "complete",
  "campaign_remaining": "Remaining",
  "campaign_waitlist": "Waitlist",
  "campaign_health": "Campaign health",
  "campaign_health_hint": "Signals from the public application funnel.",
  "campaign_needs_attention": "Needs attention",
  "campaign_on_track": "On track",
  "campaign_health_add_source": "Create at least one tracking link to see which channel produces qualified drivers.",
  "campaign_health_low_start": "Many people open the page but do not start. Review the offer and the first-screen message.",
  "campaign_health_long_form": "Candidates start but do not submit. Consider removing non-essential questions.",
  "campaign_health_good": "The funnel has no obvious bottleneck. Keep monitoring source quality and hiring pace.",
  "campaign_views": "Views",
  "campaign_started": "Started",
  "campaign_submitted": "Submitted",
  "campaign_hired": "Hired",
  "campaign_pipeline_hint": "Candidate distribution across the hiring stages.",
  "campaign_manage_candidates": "Manage candidates",
  "campaign_details": "Campaign details",
  "campaign_details_hint": "Owner, timing and offer parameters.",
  "campaign_open_date": "Open date",
  "campaign_job_types": "Job types",
  "campaign_location": "Location",
  "campaign_pay": "Pay",
  "campaign_week": "week",
  "campaign_home_time": "Home time",
  "campaign_candidates_title": "Campaign pipeline",
  "campaign_candidates_hint": "Move applicants through stages or process multiple profiles at once.",
  "campaign_no_candidates_stage": "No candidates",
  "campaign_drag_candidate": "Drag candidate",
  "campaign_select_candidates": "Select candidates for a bulk action",
  "campaign_selected_count": "Selected: {count}",
  "campaign_move_reserve": "Move to talent pool",
  "campaign_reject_selected": "Reject selected",
  "campaign_select_all": "Select all active candidates",
  "campaign_select_candidate": "Select candidate",
  "view_board": "Board",
  "campaign_source": "Source",
  "campaign_sources_title": "Acquisition channels",
  "campaign_sources_hint": "Create a unique link for each placement and compare channel quality.",
  "campaign_create_tracking_link": "Create tracking link",
  "campaign_public_link": "Default public link",
  "campaign_copy_link": "Copy link",
  "campaign_preview": "Preview",
  "campaign_applications": "Applications",
  "campaign_conversion": "Conversion",
  "campaign_spend": "Spend",
  "campaign_cost_per_hire": "Cost per hire",
  "campaign_link_active": "Link active",
  "campaign_link_disabled": "Link disabled",
  "campaign_disable": "Disable",
  "campaign_enable": "Enable",
  "campaign_direct_source": "Direct / untagged",
  "campaign_direct_source_hint": "Default link and legacy candidates",
  "campaign_form_builder_title": "Application form builder",
  "campaign_form_builder_description": "Keep only the questions needed to qualify drivers for this position.",
  "campaign_branding": "Campaign branding",
  "campaign_branding_hint": "Use a campaign-specific header image on the public page.",
  "campaign_no_banner": "Default campaign image",
  "campaign_no_banner_hint": "Upload a yard, truck or team image for this vacancy.",
  "campaign_upload_banner": "Upload header image",
  "campaign_banner_requirements": "JPG, PNG or WebP · up to 5 MB",
  "campaign_preview_application": "Preview application",
  "campaign_application_funnel": "Application funnel",
  "campaign_application_funnel_hint": "Where candidates leave the public application flow.",
  "campaign_page_views": "Page views",
  "campaign_form_starts": "Form starts",
  "campaign_from_previous": "from previous step",
  "campaign_efficiency": "Campaign efficiency",
  "campaign_efficiency_hint": "Operational KPIs for this vacancy.",
  "campaign_hire_rate": "Hire rate",
  "campaign_goal_progress": "Goal progress",
  "campaign_source_quality": "Source quality",
  "campaign_source_quality_hint": "Compare traffic, applicants, hires and acquisition cost.",
  "campaign_add_update": "Post an update",
  "campaign_add_update_hint": "Record decisions and context for the recruiting team.",
  "campaign_note_placeholder": "What changed and why? Mention rates, requirements, channel decisions or blockers…",
  "campaign_publish_note": "Publish update",
  "campaign_discussion": "Campaign history",
  "campaign_discussion_hint": "A durable decision log for everyone working on this vacancy.",
  "campaign_no_notes": "No campaign updates yet",
  "campaign_no_notes_hint": "The first note will start the decision history.",
  "campaign_tracking_link_description": "Name the placement so every application and hire can be attributed correctly.",
  "campaign_source_name": "Channel or placement name",
  "campaign_source_name_placeholder": "e.g. Facebook · Chicago · September",
  "campaign_source_spend": "Spend to date, USD",
  "campaign_source_spend_hint": "Optional. Used to calculate cost per hire.",
  "campaign_create_link": "Create link",
  "campaign_close_title": "Close hiring campaign?",
  "campaign_close_description": "There are {count} active candidates. Choose what should happen to them.",
  "campaign_close_reserve": "Move to talent pool",
  "campaign_close_reserve_hint": "Unassign candidates but keep them active for future vacancies.",
  "campaign_close_reject": "Reject all",
  "campaign_close_reject_hint": "Move active candidates to Rejected and preserve the audit history.",
  "campaign_close_keep": "Leave as is",
  "campaign_close_keep_hint": "Close the public campaign without changing candidate assignments.",
  "campaign_close_confirm": "Close campaign",
  "campaign_goal_reached": "Hiring plan completed",
  "campaign_goal_reached_hint": "{hired} of {goal} drivers are hired. You can close the campaign or keep it open.",
  "campaign_keep_open": "Keep open",
  "campaign_close_now": "Review and close",
  "campaign_create_title": "Create hiring campaign",
  "campaign_edit_title": "Edit campaign",
  "campaign_editor_description": "Set the outcome, offer and application experience before publishing.",
  "campaign_setup_steps": "Campaign setup steps",
  "campaign_step_basics": "Goal & ownership",
  "campaign_step_offer": "Offer",
  "campaign_step_form": "Application",
  "campaign_budget": "Campaign budget, USD",
  "campaign_terminal": "Terminal",
  "campaign_description_placeholder": "Describe the lanes, equipment, schedule and why a driver should choose this role.",
  "campaign_weekly_pay": "Average weekly pay, USD",
  "campaign_per_mile": "Pay per mile, USD",
  "campaign_routes": "Routes / operating area",
  "campaign_min_experience": "Minimum experience, months",
  "campaign_job_types_hint": "Separate values with commas.",
  "campaign_create_and_launch": "Create campaign",
  "campaign_question_phone": "Mobile phone",
  "campaign_question_phone_hint": "Required for recruiter follow-up.",
  "campaign_question_location": "City and state",
  "campaign_question_location_hint": "Use for lane and terminal fit.",
  "campaign_question_cdl": "CDL class and issuing state",
  "campaign_question_cdl_hint": "Confirm the required commercial license.",
  "campaign_question_experience": "Total driving experience",
  "campaign_question_experience_hint": "Ask for the driver's overall commercial experience.",
  "campaign_question_otr": "OTR experience",
  "campaign_question_otr_hint": "Enable only for over-the-road positions.",
  "campaign_question_endorsements": "CDL endorsements",
  "campaign_question_endorsements_hint": "Ask about Hazmat, Tanker and other endorsements.",
  "campaign_question_safety": "Safety history",
  "campaign_question_safety_hint": "Accidents and traffic violations from the past three years.",
  "campaign_question_documents": "Document upload",
  "campaign_question_documents_hint": "Let candidates add CDL and Medical Card images.",
  "campaign_otr_months": "OTR experience, months",
  "campaign_endorsements": "Endorsements",
  "campaign_applications_paused": "Applications are temporarily paused",
  "campaign_applications_paused_hint": "Leave your email and we will let you know when this position opens again.",
  "campaign_join_waitlist": "Notify me when it reopens",
  "campaign_waitlist_success": "You're on the waitlist. We'll be in touch when applications reopen.",
  "vacancies_heading": "Vacancies",
  "vacancies_description": "Create offers, assign recruiters and monitor candidate flow.",
  "vacancies_new": "New vacancy",
  "vacancies_all_statuses": "All statuses",
  "vacancies_apply_filters": "Apply filters",
  "vacancies_candidates_label": "Candidates",
  "vacancies_drivers_needed": "Drivers needed",
  "vacancies_recruiter_label": "Recruiter",
  "vacancies_target_close": "Target close",
  "vacancies_opened": "Opened",
  "vacancies_view": "View vacancy →",
  "vacancies_placeholder": "Search vacancies…",
  "empty_no_vacancies": "No vacancies found",
  "empty_try_changing_filters": "Try changing the filters.",
  "candidate_profile": "Candidate profile",
  "candidate_contact_assignment": "Contact and assignment",
  "candidate_driver_summary": "Driver summary",
  "candidate_next_steps": "Next steps",
  "candidate_next_steps_description": "Upcoming activity and open work",
  "candidate_qualification_result": "Qualification result",
  "candidate_recorded_answers": "Recorded answers",
  "candidate_experience": "Employment and driving experience",
  "candidate_incidents": "Accidents and violations",
  "candidate_interviews": "Interviews",
  "candidate_documents": "Documents",
  "candidate_notes": "Internal notes",
  "candidate_add_note": "Add note",
  "candidate_activity": "Complete activity history",
  "candidate_schedule_interview": "Schedule interview",
  "candidate_update_interview": "Update interview",
  "candidate_create_task": "Create task",
  "candidate_upload_document": "Upload document",
  "candidate_add_employer": "Add employer",
  "candidate_add_incident": "Add accident or violation",
  "candidate_edit_profile": "Edit profile",
  "candidate_tab_overview": "Overview",
  "candidate_tab_qualification": "Qualification",
  "candidate_tab_experience": "Experience",
  "candidate_tab_incidents": "Accidents & violations",
  "candidate_tab_interviews": "Interviews",
  "candidate_tab_documents": "Documents",
  "candidate_tab_notes": "Notes",
  "candidate_tab_activity": "Activity",
  "candidate_phone": "Phone",
  "candidate_email": "Email",
  "candidate_address": "Address",
  "candidate_preferred_contact": "Preferred contact",
  "candidate_source": "Source",
  "candidate_available_date": "Available date",
  "candidate_cdl": "CDL",
  "candidate_cdl_expiry": "CDL expiry",
  "candidate_medical_expiry": "Medical Card expiry",
  "candidate_total_experience": "Total experience",
  "candidate_endorsements": "Endorsements",
  "candidate_manual_transmission": "Manual transmission",
  "candidate_equipment": "Equipment",
  "candidate_reason_leaving": "Reason for leaving",
  "candidate_recruiter_label": "Recruiter",
  "candidate_qualification_label": "Qualification",
  "candidate_compliance_label": "Compliance",
  "candidate_added_label": "Added",
  "candidate_months": "months",
  "candidate_yes": "Yes",
  "candidate_no": "No",
  "candidate_none": "None",
  "candidate_class": "Class",
  "candidate_no_number": "No number",
  "candidate_cdl_not_specified": "CDL not specified",
  "candidate_pin_note": "Pin important note",
  "candidate_save_review": "Save review",
  "candidate_upload_file": "Upload file",
  "candidate_versions": "Versions",
  "candidate_review": "Review",
  "candidate_driver_path": "DriverPath",
  "candidate_risk_score": "Risk Score",
  "candidate_compliance": "Compliance",
  "candidate_add_record": "Add record",
  "candidate_incident_accident": "Accident",
  "candidate_incident_violation": "Violation",
  "candidate_incident_license_suspension": "License suspension",
  "candidate_incident_drug_refusal": "Drug screening refusal",
  "candidate_severity_minor": "minor",
  "candidate_severity_moderate": "moderate",
  "candidate_severity_serious": "serious",
  "candidate_interview_result_no_result": "No result",
  "candidate_interview_result_suitable": "Suitable",
  "candidate_interview_result_additional": "Additional review",
  "candidate_interview_result_send_docs": "Send to documents",
  "candidate_interview_result_reject": "Reject",
  "candidate_interview_result_declined": "Candidate declined",
  "candidate_interview_duration": "Duration, minutes",
  "candidate_interview_format": "Format",
  "candidate_interview_location": "Location or link",
  "candidate_interview_responsible": "Responsible",
  "candidate_interview_comment": "Comment",
  "candidate_format_phone": "Phone",
  "candidate_format_video": "Video",
  "candidate_format_office": "Office",
  "candidate_format_other": "Other",
  "candidate_task_title": "Task title",
  "candidate_task_description": "Description",
  "candidate_task_due": "Due date and time",
  "candidate_task_priority": "Priority",
  "candidate_task_assignee": "Assignee",
  "candidate_task_category": "Category",
  "candidate_priority_low": "Low",
  "candidate_priority_medium": "Medium",
  "candidate_priority_high": "High",
  "candidate_priority_urgent": "Urgent",
  "candidate_doc_file": "File",
  "candidate_doc_type": "Document type",
  "candidate_doc_name": "Document name",
  "candidate_doc_number": "Number",
  "candidate_doc_issue_date": "Issue date",
  "candidate_doc_expiry_date": "Expiry date",
  "candidate_doc_status": "Status",
  "candidate_doc_replace": "Replace existing document",
  "candidate_doc_new": "Create new document",
  "candidate_doc_comment": "Comment",
  "candidate_emp_employer": "Employer",
  "candidate_emp_position": "Position",
  "candidate_emp_start_date": "Start date",
  "candidate_emp_end_date": "End date",
  "candidate_emp_route_types": "Route types",
  "candidate_emp_equipment_types": "Equipment types",
  "candidate_emp_reason": "Reason for leaving",
  "candidate_incident_type": "Type",
  "candidate_incident_date": "Date",
  "candidate_incident_severity": "Severity",
  "candidate_incident_description": "Description",
  "candidate_incident_document": "Document",
  "candidate_incident_comment": "Comment",
  "candidate_interview_datetime": "Date and time",
  "candidate_interview_status": "Status",
  "candidate_interview_result": "Result",
  "candidate_interview_notes": "Notes",
  "candidate_doc_document": "Document",
  "candidate_doc_issue": "Issue date",
  "candidate_doc_expiry": "Expiry",
  "candidate_doc_uploaded": "Uploaded",
  "candidate_doc_verified": "Verified by",
  "candidate_system": "System",
  "candidate_no_ip": "No IP",
  "candidate_profile_completeness": "profile completeness",
  "candidate_items_need_attention": "item(s) need attention.",
  "candidate_qual_automatic": "Automatic result:",
  "candidate_qual_manual_changed": "Manually changed with a required comment.",
  "candidate_qual_reasons": "Reasons",
  "candidate_qual_manual_comment": "Manual decision comment",
  "candidate_qual_rules_met": "All configured rules are satisfied.",
  "candidate_driver": "Driver",
  "candidate_routes_not_set": "Routes not set",
  "empty_no_answers": "No answers recorded",
  "empty_complete_qualification": "Complete the qualification questionnaire.",
  "empty_no_employment": "No employment history",
  "empty_add_employers": "Add previous employers to improve compliance completeness.",
  "empty_no_incidents": "No incidents recorded",
  "empty_no_incidents_desc": "This candidate has no listed accidents or violations.",
  "empty_no_interviews": "No interviews found",
  "empty_create_first_interview": "Create the first interview for this candidate.",
  "empty_no_documents": "No documents found",
  "empty_upload_cdl_docs": "Upload CDL, Medical Card and application files.",
  "empty_no_notes": "No internal notes",
  "empty_add_context": "Add context for the recruiting team.",
  "empty_no_activity": "No activity recorded",
  "empty_actions_appear_here": "Actions on this profile will appear here.",
  "candidate_form_edit": "Edit candidate",
  "candidate_form_add": "Add candidate",
  "candidate_form_description": "Create a complete driver profile and connect it to the right vacancy.",
  "candidate_form_personal": "Personal information",
  "candidate_form_assignment": "Assignment",
  "candidate_form_driver_info": "Driver information",
  "candidate_form_experience": "Experience",
  "candidate_form_preferences": "Preferences and notes",
  "candidate_form_first_name": "First name",
  "candidate_form_last_name": "Last name",
  "candidate_form_birth_date": "Date of birth",
  "candidate_form_phone": "Phone",
  "candidate_form_secondary_phone": "Secondary phone",
  "candidate_form_email": "Email",
  "candidate_form_address": "Address",
  "candidate_form_city": "City",
  "candidate_form_state": "State",
  "candidate_form_zip": "ZIP code",
  "candidate_form_preferred_contact": "Preferred contact",
  "candidate_form_source": "Source",
  "candidate_form_vacancy": "Current vacancy",
  "candidate_form_recruiter": "Recruiter",
  "candidate_form_stage": "Pipeline stage",
  "candidate_form_use_default_stage": "Use default stage",
  "candidate_form_cdl_class": "CDL Class",
  "candidate_form_cdl_number": "CDL Number",
  "candidate_form_cdl_state": "CDL state",
  "candidate_form_cdl_issue": "Issue date",
  "candidate_form_cdl_expiry": "CDL expiry",
  "candidate_form_endorsements": "Endorsements",
  "candidate_form_restrictions": "Restrictions",
  "candidate_form_medical_number": "Medical Card number",
  "candidate_form_medical_expiry": "Medical Card expiry",
  "candidate_form_total_exp": "Total driving experience, months",
  "candidate_form_req_exp": "Required equipment, months",
  "candidate_form_otr_exp": "OTR experience, months",
  "candidate_form_local_exp": "Local experience, months",
  "candidate_form_regional_exp": "Regional experience, months",
  "candidate_form_manual_exp": "Manual transmission experience",
  "candidate_form_desired_salary": "Desired salary",
  "candidate_form_preferred_route": "Preferred route",
  "candidate_form_home_time": "Desired home time",
  "candidate_form_available_date": "Available date",
  "candidate_form_relocate": "Willing to relocate",
  "candidate_form_comment": "Candidate comment",
  "candidate_form_notes": "Internal notes",
  "candidate_form_save": "Save changes",
  "vacancy_form_edit": "Edit vacancy",
  "vacancy_form_new": "New vacancy",
  "vacancy_form_create": "Create vacancy",
  "vacancy_form_description": "Define the offer, operating area, compensation and qualification rules.",
  "vacancy_form_core": "Core information",
  "vacancy_form_work_type": "Work type",
  "vacancy_form_geography": "Geography",
  "vacancy_form_compensation": "Compensation",
  "vacancy_form_schedule": "Schedule",
  "vacancy_form_requirements": "Requirements",
  "vacancy_form_benefits": "Benefits and equipment",
  "vacancy_form_title": "Vacancy title",
  "vacancy_form_status": "Status",
  "vacancy_form_drivers_required": "Drivers required",
  "vacancy_form_terminal": "Terminal",
  "vacancy_form_recruiter": "Responsible recruiter",
  "vacancy_form_open_date": "Open date",
  "vacancy_form_target_close": "Target close date",
  "vacancy_form_description_label": "Description",
  "vacancy_form_job_type_company": "Company Driver",
  "vacancy_form_job_type_owner": "Owner Operator",
  "vacancy_form_job_type_local": "Local",
  "vacancy_form_job_type_regional": "Regional",
  "vacancy_form_job_type_dedicated": "Dedicated",
  "vacancy_form_job_type_otr": "OTR",
  "vacancy_form_job_type_fulltime": "Full Time",
  "vacancy_form_job_type_parttime": "Part Time",
  "vacancy_form_state": "State",
  "vacancy_form_city": "City",
  "vacancy_form_zip": "ZIP code",
  "vacancy_form_radius": "Search radius, miles",
  "vacancy_form_routes": "Main routes",
  "vacancy_form_allowed_states": "Allowed states",
  "vacancy_form_per_mile": "Pay per mile",
  "vacancy_form_hourly": "Hourly pay",
  "vacancy_form_weekly": "Weekly pay",
  "vacancy_form_guaranteed_weekly": "Guaranteed weekly",
  "vacancy_form_average_weekly": "Average weekly",
  "vacancy_form_sign_on_bonus": "Sign-on bonus",
  "vacancy_form_detention_pay": "Detention pay",
  "vacancy_form_stop_pay": "Stop pay",
  "vacancy_form_layover_pay": "Layover pay",
  "vacancy_form_bonuses": "Additional bonuses",
  "vacancy_form_working_days": "Working days",
  "vacancy_form_days_off": "Days off",
  "vacancy_form_home_time": "Home time",
  "vacancy_form_trip_length": "Trip duration",
  "vacancy_form_shift": "Shift",
  "vacancy_form_cdl_class": "CDL Class",
  "vacancy_form_min_age": "Minimum age",
  "vacancy_form_min_experience": "Minimum experience, months",
  "vacancy_form_req_endorsements": "Required endorsements",
  "vacancy_form_max_accidents": "Max accidents",
  "vacancy_form_max_violations": "Max violations",
  "vacancy_form_employment_history": "Employment history, months",
  "vacancy_form_medical_card": "Valid Medical Card",
  "vacancy_form_manual_transmission": "Manual transmission",
  "vacancy_form_drug_screening": "Drug screening",
  "vacancy_form_any": "Any",
  "vacancy_form_medical": "Medical insurance",
  "vacancy_form_dental": "Dental",
  "vacancy_form_vision": "Vision",
  "vacancy_form_pto": "Paid time off",
  "vacancy_form_retirement": "Retirement plan",
  "vacancy_form_new_trucks": "Newer fleet",
  "vacancy_form_equipment": "Equipment",
  "vacancy_form_truck_age": "Truck age",
  "vacancy_form_transmission": "Transmission",
  "vacancy_form_auto": "Automatic",
  "vacancy_form_manual": "Manual",
  "vacancy_form_both": "Both",
  "vacancy_detail_heading": "Vacancy workspace",
  "vacancy_detail_offer": "Offer details",
  "vacancy_detail_linked": "Linked candidates",
  "vacancy_detail_offerscore": "OfferScore breakdown",
  "vacancy_detail_recommendations": "Recommendations",
  "vacancy_detail_change_status": "Change status",
  "vacancy_detail_candidates_linked": "candidates currently linked to this offer.",
  "vacancy_detail_recruiter": "Recruiter",
  "vacancy_detail_terminal": "Terminal",
  "vacancy_detail_opened": "Opened",
  "vacancy_detail_drivers_required": "Drivers required",
  "vacancy_detail_offerscore_label": "OfferScore",
  "vacancy_detail_job_types": "Job types",
  "vacancy_detail_location": "Location",
  "vacancy_detail_avg_weekly": "Average weekly pay",
  "vacancy_detail_guaranteed_weekly": "Guaranteed weekly pay",
  "vacancy_detail_home_time": "Home time",
  "vacancy_detail_min_experience": "Minimum experience",
  "vacancy_detail_cdl_req": "CDL requirement",
  "vacancy_detail_equipment_label": "Equipment",
  "vacancy_detail_th_candidate": "Candidate",
  "vacancy_detail_th_stage": "Stage",
  "vacancy_detail_th_qualification": "Qualification",
  "vacancy_detail_th_location": "Location",
  "vacancy_detail_th_added": "Added",
  "vacancy_detail_copy": "Copy",
  "vacancy_detail_add_candidate": "Add candidate",
  "vacancy_detail_update_status": "Update status",
  "vacancy_detail_view_kanban": "View Kanban",
  "vacancy_detail_balanced": "The offer is balanced across the configured categories.",
  "empty_no_candidates_linked": "No candidates linked",
  "empty_add_or_assign": "Add a candidate or assign an existing profile.",
  "kanban_heading": "Hiring pipeline",
  "kanban_description": "Drag candidates between stages. Every move is recorded in the activity log.",
  "kanban_add_candidate": "Add candidate",
  "kanban_apply_filters": "Apply filters",
  "kanban_all_vacancies": "All vacancies",
  "kanban_all_recruiters": "All recruiters",
  "kanban_docs": "docs",
  "interviews_heading": "Interviews",
  "interviews_schedule": "Schedule interview",
  "interviews_update": "Update interview",
  "interviews_description": "Schedule, review and track driver interviews without an external calendar.",
  "interviews_apply": "Apply",
  "interviews_all_recruiters": "All recruiters",
  "interviews_all_vacancies": "All vacancies",
  "interviews_all_statuses": "All statuses",
  "interviews_list_view": "List view",
  "interviews_day_view": "Day view",
  "interviews_week_view": "Week view",
  "interviews_month_view": "Month view",
  "interviews_prev": "← Previous",
  "interviews_next": "Next →",
  "interviews_monday": "Monday",
  "interviews_tuesday": "Tuesday",
  "interviews_wednesday": "Wednesday",
  "interviews_thursday": "Thursday",
  "interviews_friday": "Friday",
  "interviews_saturday": "Saturday",
  "interviews_sunday": "Sunday",
  "interviews_th_datetime": "Date and time",
  "interviews_th_candidate": "Candidate",
  "interviews_th_vacancy": "Vacancy",
  "interviews_th_recruiter": "Recruiter",
  "interviews_th_format": "Format",
  "interviews_th_status": "Status",
  "interviews_th_result": "Result",
  "interviews_form_candidate": "Candidate",
  "interviews_form_vacancy": "Vacancy",
  "interviews_form_datetime": "Date and time",
  "interviews_form_duration": "Duration",
  "interviews_form_format": "Format",
  "interviews_form_responsible": "Responsible",
  "interviews_form_location": "Location or link",
  "interviews_form_comment": "Comment",
  "interviews_form_result": "Result",
  "interviews_form_next_step": "Next step",
  "interviews_form_notes": "Notes",
  "interviews_select_candidate": "Select candidate",
  "interviews_use_vacancy": "Use candidate vacancy",
  "interviews_minutes": "minutes",
  "interviews_all_scheduled": "All scheduled interviews",
  "empty_create_first": "Create the first interview to begin.",
  "tasks_heading": "Tasks",
  "tasks_create": "Create task",
  "tasks_description": "Follow-ups, document checks and hiring decisions with clear ownership.",
  "tasks_apply": "Apply",
  "tasks_all_statuses": "All statuses",
  "tasks_all_assignees": "All assignees",
  "tasks_all_priorities": "All priorities",
  "tasks_th_task": "Task",
  "tasks_th_candidate_vacancy": "Candidate / vacancy",
  "tasks_th_assignee": "Assignee",
  "tasks_th_due": "Due",
  "tasks_th_priority": "Priority",
  "tasks_th_status": "Status",
  "tasks_th_update": "Update",
  "tasks_form_title": "Task title",
  "tasks_form_description": "Description",
  "tasks_form_candidate": "Candidate",
  "tasks_form_vacancy": "Vacancy",
  "tasks_form_assignee": "Assignee",
  "tasks_form_due": "Due",
  "tasks_form_priority": "Priority",
  "tasks_form_category": "Category",
  "tasks_past_deadline": "Past deadline",
  "empty_no_tasks": "No tasks found",
  "empty_create_or_filter": "Create a task or change the filters.",
  "documents_heading": "Document center",
  "documents_review": "Review",
  "documents_description": "Review candidate files, expiration dates and compliance status.",
  "documents_all_statuses": "All statuses",
  "documents_all_types": "All document types",
  "documents_th_document": "Document",
  "documents_th_candidate": "Candidate",
  "documents_th_type": "Type",
  "documents_th_status": "Status",
  "documents_th_number": "Number",
  "documents_th_expiry": "Expiry",
  "documents_th_uploaded_by": "Uploaded by",
  "documents_th_verified_by": "Verified by",
  "documents_form_status": "Status",
  "documents_form_comment": "Comment",
  "empty_docs_from_profiles": "Documents are uploaded from candidate profiles.",
  "reports_heading": "Recruiting reports",
  "reports_description": "Simple operational analytics for the selected period.",
  "reports_funnel_heading": "Hiring funnel",
  "reports_funnel_description": "Candidate count by current stage",
  "reports_outcome_heading": "Outcome conversion",
  "reports_recruiter_heading": "Recruiter performance",
  "reports_vacancy_heading": "Vacancy performance",
  "reports_period_30": "30 days",
  "reports_period_90": "90 days",
  "reports_period_180": "180 days",
  "reports_period_365": "1 year",
  "reports_export_funnel": "Export funnel CSV",
  "reports_total_candidates": "Total candidates",
  "reports_qualified": "Qualified",
  "reports_interviewed": "Interviewed",
  "reports_approved": "Approved",
  "reports_hired": "Hired",
  "reports_rejected": "Rejected",
  "reports_withdrawn": "Withdrawn",
  "reports_th_recruiter": "Recruiter",
  "reports_th_candidates": "Candidates",
  "reports_th_completed_interviews": "Completed interviews",
  "reports_th_hired": "Hired",
  "reports_th_overdue": "Overdue tasks",
  "reports_th_vacancy": "Vacancy",
  "reports_th_qualified": "Qualified",
  "reports_th_conversion": "Conversion",
  "reports_th_avg_days": "Average time to hire",
  "reports_days": "days",
  "employees_heading": "Employees",
  "employees_add": "Add employee",
  "employees_edit_name": "Edit employee name",
  "employees_description": "Who works here and what each of them may do.",
  "employees_create": "Create employee",
  "employees_th_employee": "Employee",
  "employees_th_role": "Role",
  "employees_th_position": "Position",
  "employees_th_terminal": "Terminal",
  "employees_th_vacancies": "Vacancies",
  "employees_th_last_login": "Last login",
  "employees_th_status": "Status",
  "employees_form_first_name": "First name",
  "employees_form_last_name": "Last name",
  "employees_form_email": "Email",
  "employees_form_password": "Temporary password",
  "employees_form_phone": "Phone",
  "employees_form_position": "Position",
  "employees_form_role": "Role",
  "employees_form_terminal": "Terminal",
  "company_heading": "Company profile",
  "company_information": "Company information",
  "company_terminals": "Terminals and offices",
  "company_add_terminal": "Add terminal",
  "company_description": "Legal, operating and terminal information for your workspace.",
  "company_operating_locations": "operating location(s).",
  "company_save": "Save company",
  "company_create_terminal": "Create terminal",
  "company_form_name": "Display name",
  "company_form_legal_name": "Legal name",
  "company_form_status": "Status",
  "company_form_dot": "DOT Number",
  "company_form_mc": "MC Number",
  "company_form_website": "Website",
  "company_form_phone": "Phone",
  "company_form_email": "Email",
  "company_form_fleet_size": "Fleet size",
  "company_form_employee_count": "Employee count",
  "company_form_address": "Address",
  "company_form_city": "City",
  "company_form_state": "State",
  "company_form_zip": "ZIP code",
  "company_form_description": "Description",
  "company_form_terminal_name": "Name",
  "company_form_manager": "Manager",
  "company_terminal_label": "Terminal",
  "company_terminal_phone": "Phone",
  "company_terminal_manager": "Manager",
  "company_workspace": "Company workspace",
  "empty_no_terminals": "No terminals configured",
  "empty_add_first_terminal": "Add your first operating location.",
  "settings_heading": "Company settings",
  "settings_stages_heading": "Hiring stages",
  "settings_rules_heading": "Rules and dictionaries",
  "settings_qualification_heading": "Qualification rules",
  "settings_risk_heading": "Risk deductions",
  "settings_dictionaries_heading": "Dictionaries",
  "settings_add_stage": "Add hiring stage",
  "settings_description": "Configure the hiring workflow, qualification, risk and system dictionaries.",
  "settings_stages_description": "Change pipeline stage names, colors and order. Each row saves independently.",
  "settings_rules_description": "Shared candidate evaluation rules and values used throughout working forms.",
  "settings_qualification_description": "Minimum requirements used by automatic qualification.",
  "settings_risk_description": "Points deducted for each risk factor.",
  "settings_dictionaries_description": "Separate values with commas; they will appear in the related forms.",
  "settings_stage_order": "Order",
  "settings_stage_actions": "Actions",
  "settings_points_short": "pts",
  "settings_save_hint": "Rule and dictionary changes apply to the whole company.",
  "settings_save": "Save",
  "settings_create_stage": "Create stage",
  "settings_qual_min_experience": "Minimum experience, months",
  "settings_qual_cdl_required": "CDL required",
  "settings_qual_endorsements": "Required endorsements",
  "settings_qual_max_accidents": "Max accidents",
  "settings_qual_max_violations": "Max violations",
  "settings_qual_allowed_states": "Allowed states",
  "settings_qual_medical_card": "Medical Card required",
  "settings_risk_expired_cdl": "Expired CDL",
  "settings_risk_missing_medical": "Missing Medical Card",
  "settings_risk_serious_violation": "Serious violation",
  "settings_risk_accident": "Accident",
  "settings_risk_employment_gap": "Employment gap",
  "settings_risk_insufficient_exp": "Insufficient experience",
  "settings_risk_incomplete_docs": "Incomplete documents",
  "settings_dict_required_docs": "Required documents",
  "settings_dict_candidate_sources": "Candidate sources",
  "settings_dict_document_types": "Document types",
  "settings_dict_task_categories": "Task categories",
  "settings_stage_name": "Stage name",
  "settings_stage_color": "Color",
  "settings_stage_final": "Final stage",
  "settings_stage_final_type": "Final type",
  "settings_final_type_none": "No final type",
  "settings_delete_stage_confirm": "Delete this unused stage?",
  "notifications_heading": "Notification center",
  "notifications_description": "Assignments, due dates, interviews and document alerts inside the system.",
  "notifications_mark_all": "Mark all as read",
  "notifications_mark_read": "Mark read",
  "notifications_filter_label": "Notification filter",
  "notifications_all": "All",
  "notifications_unread": "New",
  "notifications_read": "Read",
  "notifications_new": "New",
  "notifications_open": "Open",
  "notifications_show_all": "Show all notifications",
  "empty_no_unread_notifications": "No new notifications",
  "empty_no_unread_notifications_desc": "You have read all current notifications.",
  "empty_no_notifications": "No notifications",
  "empty_new_alerts_here": "New activity alerts will appear here.",
  "audit_heading": "Audit log",
  "audit_description": "Immutable history of logins, edits, decisions and document actions.",
  "audit_placeholder_action": "Action, e.g. edit",
  "audit_placeholder_entity": "Entity, e.g. candidate",
  "audit_th_datetime": "Date and time",
  "audit_th_user": "User",
  "audit_th_action": "Action",
  "audit_th_entity": "Entity",
  "audit_th_old": "Old value",
  "audit_th_new": "New value",
  "audit_th_ip": "IP address",
  "audit_system_unknown": "System / unknown",
  "empty_no_audit": "No audit entries",
  "profile_heading": "My profile",
  "profile_account_info": "Account information",
  "profile_change_password": "Change password",
  "profile_description": "Account details and password security.",
  "profile_email": "Email",
  "profile_phone": "Phone",
  "profile_position": "Position",
  "profile_role": "Role",
  "profile_status": "Status",
  "profile_last_login": "Last login",
  "profile_company": "Company",
  "profile_password_hint": "Use at least 8 characters.",
  "profile_current_password": "Current password",
  "profile_new_password": "New password",
  "profile_confirm_password": "Confirm new password",
  "profile_update_password": "Update password",
  "profile_platform_admin": "Platform administration",
  "admin_heading": "System administration",
  "admin_companies": "Companies",
  "admin_users": "Users",
  "admin_create_company": "Create company",
  "admin_create_user": "Create platform user",
  "admin_description": "Manage companies, platform users and workspace availability.",
  "admin_create_user_btn": "Create user",
  "admin_save": "Save",
  "admin_metric_companies": "Companies",
  "admin_metric_users": "Platform users",
  "admin_metric_active": "Active companies",
  "admin_metric_blocked": "Blocked companies",
  "admin_th_company": "Company",
  "admin_th_dot_mc": "DOT / MC",
  "admin_th_location": "Location",
  "admin_th_users": "Users",
  "admin_th_fleet": "Fleet",
  "admin_th_created": "Created",
  "admin_th_status": "Status",
  "admin_th_user": "User",
  "admin_th_role": "Role",
  "admin_th_last_login": "Last login",
  "admin_company_name": "Company name",
  "admin_legal_name": "Legal name",
  "admin_dot_number": "DOT Number",
  "admin_mc_number": "MC Number",
  "admin_form_email": "Email",
  "admin_form_phone": "Phone",
  "admin_form_city": "City",
  "admin_form_state": "State",
  "admin_user_first_name": "First name",
  "admin_user_last_name": "Last name",
  "admin_user_email": "Email",
  "admin_user_password": "Temporary password",
  "admin_user_company": "Company",
  "admin_user_platform": "Platform user",
  "admin_user_role": "Role",
  "admin_user_position": "Position",
  "admin_platform": "Platform",
  "admin_company_recent_candidates": "Recent candidates",
  "admin_company_vacancies": "Vacancies",
  "admin_company_employees": "Employees",
  "admin_company_documents": "Documents",
  "admin_company_back": "Back to administration",
  "admin_company_metric_users": "Users",
  "admin_company_metric_vacancies": "Vacancies",
  "admin_company_metric_candidates": "Candidates",
  "admin_company_metric_documents": "Documents",
  "admin_company_th_candidate": "Candidate",
  "admin_company_th_vacancy": "Vacancy",
  "admin_company_th_stage": "Stage",
  "admin_company_th_recruiter": "Recruiter",
  "admin_company_th_qualification": "Qualification",
  "admin_company_th_added": "Added",
  "admin_company_th_title": "Title",
  "admin_company_th_status": "Status",
  "admin_company_th_drivers": "Drivers required",
  "admin_company_th_opened": "Opened",
  "admin_company_th_name": "Name",
  "admin_company_th_email": "Email",
  "admin_company_th_role": "Role",
  "admin_company_th_doc_type": "Type",
  "admin_company_th_doc_status": "Status",
  "admin_company_th_expiry": "Expiry",
  "compliance_heading": "Compliance checklist",
  "compliance_driver_file": "Driver qualification file",
  "compliance_overall_status": "overall status:",
  "compliance_update_items": "Update each item as manual checks and documents are completed.",
  "compliance_profile": "Profile",
  "compliance_open_driverpath": "Open DriverPath",
  "compliance_form_note": "Optional verification note",
  "driverpath_heading": "DriverPath",
  "driverpath_subheading": "Driver readiness path",
  "driverpath_identity": "Identity and driver license",
  "driverpath_medical": "Medical and experience",
  "driverpath_employment": "Employment history",
  "driverpath_incidents": "Accidents and violations",
  "driverpath_documents": "Documents",
  "driverpath_compliance": "Compliance checklist",
  "driverpath_missing": "Missing information",
  "driverpath_risk": "Risk deductions",
  "driverpath_description": "Unified driver readiness and compliance summary for {name}.",
  "driverpath_profile": "Profile",
  "driverpath_checklist": "Checklist",
  "driverpath_risk_details": "Risk details",
  "driverpath_ready": "Ready for review",
  "driverpath_incomplete": "Incomplete",
  "driverpath_cdl": "CDL",
  "driverpath_cdl_state": "CDL state",
  "driverpath_cdl_expiry": "CDL expiry",
  "driverpath_endorsements": "Endorsements",
  "driverpath_medical_card": "Medical Card",
  "driverpath_medical_expiry": "Medical expiry",
  "driverpath_total_experience": "Total experience",
  "driverpath_otr": "OTR / Regional / Local",
  "driverpath_completeness": "Profile completeness",
  "driverpath_cdl_expires": "CDL expires",
  "driverpath_medical_expires": "Medical Card expires",
  "driverpath_missing_missing": "Missing",
  "driverpath_no_number": "No number",
  "driverpath_no_cdl": "No CDL",
  "driverpath_none": "None",
  "driverpath_no_missing": "No missing information detected.",
  "driverpath_no_risk": "No risk deductions applied.",
  "driverpath_no_employment": "Employment history is missing.",
  "driverpath_months_exp": "months experience",
  "driverpath_months": "months",
  "qualification_heading": "Candidate qualification",
  "qualification_questionnaire": "Prequalification questionnaire",
  "qualification_automatic_result": "Current automatic result",
  "qualification_applied_rules": "Applied rules",
  "qualification_description": "Answers are evaluated against company and vacancy rules.",
  "qualification_back": "Back to profile",
  "qualification_save": "Save qualification",
  "qualification_has_cdl": "Has a valid CDL",
  "qualification_cdl_class": "CDL Class",
  "qualification_experience": "Experience, months",
  "qualification_home_state": "Home state",
  "qualification_route_ready": "Ready for required route",
  "qualification_home_time": "Home time is acceptable",
  "qualification_accidents": "Accidents",
  "qualification_violations": "Violations",
  "qualification_medical_card": "Valid Medical Card",
  "qualification_screening_ready": "Ready for screening",
  "qualification_available_date": "Available date",
  "qualification_manual_heading": "Manual qualification decision",
  "qualification_manual_result": "Manual result",
  "qualification_manual_comment": "Comment",
  "qualification_no_override": "No manual override",
  "qualification_rules_met": "All configured rules are met.",
  "qualification_no_vacancy": "No vacancy assigned",
  "risk_heading": "Risk Score",
  "risk_applied_deductions": "Applied deductions",
  "risk_categories": "Risk categories",
  "risk_manual_decision": "Manual decision",
  "risk_description": "Transparent rules-based risk analysis for {name}.",
  "risk_score_explanation": "The score starts at 100 and decreases when configured risk rules match candidate information.",
  "risk_after_deductions": "After all automatic deductions",
  "risk_back": "Back to profile",
  "risk_save_decision": "Save decision",
  "risk_from_start": "from start points",
  "risk_category_low": "Low Risk",
  "risk_category_moderate": "Moderate Risk",
  "risk_category_high": "High Risk",
  "risk_category_critical": "Critical Review",
  "risk_range_low": "85–100",
  "risk_range_moderate": "70–84",
  "risk_range_high": "50–69",
  "risk_range_critical": "0–49",
  "risk_decision": "Decision",
  "risk_override_category": "Override category",
  "risk_decision_comment": "Comment",
  "risk_decision_approved": "Approved",
  "risk_decision_rejected": "Rejected",
  "risk_decision_hold": "Hold",
  "risk_source": "Source:",
  "risk_final_score": "Final score",
  "empty_no_risk_triggered": "No configured risk rules were triggered.",
  "doc_versions_heading": "Document versions",
  "doc_versions_current": "Current version",
  "doc_versions_previous": "Previous versions",
  "doc_versions_back": "Back to candidate",
  "doc_versions_download_current": "Download current",
  "doc_versions_download": "Download",
  "doc_versions_status": "Status",
  "doc_versions_updated": "Updated",
  "doc_versions_uploaded_by": "Uploaded by",
  "doc_versions_expiry": "Expiry",
  "doc_versions_th_file": "File",
  "doc_versions_th_uploaded_by": "Uploaded by",
  "doc_versions_th_date": "Date",
  "doc_versions_th_comment": "Comment",
  "empty_no_versions": "No previous versions",
  "empty_versions_after_replace": "A history appears after this document is replaced.",
  "doc_versions_unknown_candidate": "Unknown candidate",
  "job_type_company_driver": "Company Driver",
  "job_type_owner_operator": "Owner Operator",
  "job_type_local": "Local",
  "job_type_regional": "Regional",
  "job_type_dedicated": "Dedicated",
  "job_type_full_time": "Full Time",
  "job_type_part_time": "Part Time",
  "vacancy_form_mandatory": "Mandatory conditions",
  "vacancy_detail_class": "Class",
  "vacancy_detail_any": "Any",
  "vacancy_detail_pipeline": "Current pipeline for this vacancy",
  "no_dot": "No DOT",
  "preferred_contact_phone": "Phone",
  "preferred_contact_sms": "SMS",
  "preferred_contact_email": "Email",
  "btn_close": "Close",
  "vacancy_copy_suffix": "(Copy)",
  "interview_week_of": "Week of {date}",
  "interview_all_scheduled": "All scheduled interviews",
  "doc_previous_version": "Previous version",
  "notification_message_assigned": "{name} was assigned to you.",
  "notification_message_stage_changed": "{name} moved to {stage}.",
  "notification_message_manual_review": "{name} requires a manual decision.",
  "notification_message_interview": "Interview with {name} on {date}.",
  "notification_message_task_due": "{title} is due {date}.",
  "notification_task_overdue": "Task overdue: {title}",
  "notification_message_task_overdue": "The task deadline has passed.",
  "notification_task_due_soon": "Task due soon: {title}",
  "notification_message_task_due_soon": "The task is due within three days.",
  "notification_document_status": "Document {status}: {name}",
  "notification_message_document_attention": "Candidate document requires attention ({status}).",
  "notification_document_reviewed": "Document {status}",
  "status_active_label": "Active",
  "status_paused_label": "Paused",
  "status_closed_label": "Closed",
  "status_archived_label": "Archived",
  "status_draft_label": "Draft",
  "btn_open": "Open",
  "btn_open_nav": "Open navigation",
  "nav_notifications": "Notifications",
  "reset_password_new_password": "New password",
  "reset_password_confirm": "Confirm new password",
  "forgot_password_demo_note": "This standalone edition has no email delivery, so the one-time link is shown here for you to open directly.",
  "confirm_ok": "Confirm",
  "confirm_cancel": "Cancel",
  "kanban_move_to": "Move to stage",
  "error_page_title": "Error",
  "qualification_rule_minimum_experience_months": "Minimum experience (months)",
  "qualification_rule_cdl_required": "CDL required",
  "qualification_rule_required_endorsements": "Required endorsements",
  "qualification_rule_max_accidents": "Maximum accidents",
  "qualification_rule_max_violations": "Maximum violations",
  "qualification_rule_allowed_states": "Allowed states",
  "qualification_rule_medical_card_required": "Valid Medical Card required",
  "qualification_rule_cdl_class": "CDL class",
  "qualification_reason_missing_cdl": "CDL information is missing.",
  "qualification_reason_missing_state": "Home state is missing.",
  "qualification_reason_experience": "Experience is below the required {months} months.",
  "qualification_reason_cdl_class_mismatch": "CDL class {required} is required — the candidate has class {actual}.",
  "qualification_reason_experience_below": "Experience ({actual} mos) is below the required {required} months.",
  "qualification_reason_accidents_over": "Accidents ({actual}) exceed the allowed maximum of {max}.",
  "qualification_reason_violations_over": "Violations ({actual}) exceed the allowed maximum of {max}.",
  "qualification_reason_endorsements": "Missing endorsements: {endorsements}.",
  "qualification_reason_accidents": "The permitted number of accidents was exceeded.",
  "qualification_reason_violations": "The permitted number of violations was exceeded.",
  "qualification_reason_state": "The candidate's state is outside the allowed region.",
  "qualification_reason_missing_medical": "Medical Card information is missing.",
  "qualification_reason_expired_medical": "The Medical Card has expired.",
  "qualification_reason_contact": "Contact information is incomplete.",
  "risk_rule_expired_cdl": "Expired CDL",
  "risk_rule_missing_medical_card": "Missing Medical Card",
  "risk_rule_expired_medical_card": "Expired Medical Card",
  "risk_rule_serious_violation": "Serious violation",
  "risk_rule_accident": "Accident",
  "risk_rule_employment_incomplete": "Employment history incomplete",
  "risk_rule_insufficient_experience": "Insufficient experience",
  "risk_rule_incomplete_documents": "Incomplete documents",
  "risk_source_cdl_expiry": "Candidate CDL expiry",
  "risk_source_candidate_profile": "Candidate profile",
  "risk_source_medical_expiry": "Candidate Medical Card expiry",
  "risk_source_serious_violations": "{count} serious violation(s)",
  "risk_source_accident_history": "Accident history",
  "risk_source_no_employers": "No employers recorded",
  "risk_source_total_experience": "Total driving experience",
  "risk_source_required_documents": "Required document list",
  "completeness_missing_cdl": "CDL is missing",
  "completeness_expired_cdl": "CDL has expired",
  "completeness_missing_medical": "Medical Card is missing",
  "completeness_expired_medical": "Medical Card has expired",
  "completeness_empty_employment": "Employment history is empty",
  "completeness_missing_document": "Required document is missing: {document}",
  "completeness_incomplete_profile": "Required profile fields are incomplete",
  "offer_recommendation_pay": "Increase guaranteed weekly pay or clarify average weekly earnings.",
  "offer_recommendation_experience": "Reduce minimum experience requirements when operationally possible.",
  "offer_recommendation_home_time": "Improve or describe the home-time schedule more clearly.",
  "offer_recommendation_bonus": "Add a sign-on bonus or other transparent incentives.",
  "offer_recommendation_benefits": "Describe medical, dental, vision and retirement benefits in more detail.",
  "audit_action_add_employment": "Employment added",
  "audit_action_add_incident": "Incident added",
  "audit_action_add_note": "Note added",
  "audit_action_change_stage": "Stage changed",
  "audit_action_change_status": "Status changed",
  "audit_action_compliance_update": "Compliance updated",
  "audit_action_copy": "Copied",
  "audit_action_create": "Created",
  "audit_action_delete": "Deleted",
  "audit_action_edit": "Edited",
  "audit_action_login": "Signed in",
  "audit_action_login_failed": "Sign-in failed",
  "audit_action_logout": "Signed out",
  "audit_action_manual_risk_decision": "Risk decision recorded",
  "audit_action_password_changed": "Password changed",
  "audit_action_password_reset_requested": "Password reset requested",
  "audit_action_qualification": "Qualification updated",
  "audit_action_review": "Reviewed",
  "audit_action_update": "Updated",
  "audit_action_update_settings": "Settings updated",
  "entity_type_candidate": "Candidate",
  "entity_type_candidate_note": "Candidate note",
  "entity_type_candidate_stage": "Candidate stage",
  "entity_type_document": "Document",
  "entity_type_interview": "Interview",
  "entity_type_organization": "Company",
  "entity_type_qualification": "Qualification",
  "entity_type_risk_decision": "Risk decision",
  "entity_type_stage": "Stage",
  "entity_type_task": "Task",
  "entity_type_terminal": "Terminal",
  "entity_type_user": "User",
  "entity_type_vacancy": "Vacancy",
  "admin_company_candidates": "Candidates",
  "document_type_cdl": "CDL",
  "document_type_id": "ID",
  "document_type_mvr": "MVR",
  "document_type_psp": "PSP",
  "document_type_fmcsa": "FMCSA",
  "document_type_voe": "VOE",
  "error_not_found_message": "The requested page could not be found.",
  "quick_add_label": "Create",
  "quick_add_candidate": "New candidate",
  "quick_add_candidate_hint": "Step-by-step driver profile",
  "quick_add_vacancy": "New vacancy",
  "quick_add_vacancy_hint": "Offer and requirements",
  "quick_add_task": "Create task",
  "quick_add_task_hint": "Assign an action to the team",
  "quick_add_interview": "Schedule interview",
  "quick_add_interview_hint": "Add a meeting to the calendar",
  "loading": "Loading…",
  "confirm_type_delete": "Type “DELETE” to confirm",
  "confirm_delete_word": "DELETE",
  "wizard_step_contacts": "Contacts",
  "wizard_step_cdl": "CDL details",
  "wizard_step_experience": "Experience",
  "wizard_step_preferences": "Preferences",
  "wizard_next": "Continue",
  "wizard_back": "Back",
  "quick_view_open_profile": "Open profile",
  "quick_view_completeness": "Profile completeness",
  "quick_view_last_notes": "Latest notes",
  "quick_view_missing_docs": "Documents need attention",
  "quick_view_no_notes": "No notes yet",
  "quick_view_no_doc_issues": "All required documents look good",
  "action_archive": "Move to archive",
  "action_edit": "Edit",
  "action_duplicate": "Duplicate",
  "view_table": "Table",
  "view_grid": "Grid",
  "dashboard_greeting": "Good afternoon, {name}",
  "dashboard_today_hint": "Here is what needs your attention today",
  "dashboard_all_tasks": "All tasks",
  "dashboard_show_all": "Show all",
  "dashboard_complete_task": "Complete task",
  "empty_upload_document_cta": "Upload document",
  "toast_saved": "Changes saved",
  "toast_archived": "Item moved to archive",
  "validation_required": "Complete this field",
  "validation_email": "Enter a valid email",
  "timezone_label": "Time zone",
  "quick_view_title": "Quick view",
  "settings_reorder_saved": "Stage order saved",
  "vacancy_back_to_list": "Back to vacancies",
  "vacancy_criteria_tab": "Criteria & application",
  "vacancy_criteria_heading": "Qualification criteria",
  "vacancy_criteria_description": "Configure hard and nice-to-have requirements for automatic qualification.",
  "criterion_name": "Criterion",
  "criterion_value": "Value",
  "criterion_type": "Requirement type",
  "criterion_hard": "Required",
  "criterion_nice": "Nice to have",
  "criterion_cdl_help": "Required commercial license class",
  "criterion_experience_help": "Verified commercial driving experience",
  "criterion_three_years": "During the last 3 years",
  "criterion_medical_help": "Valid DOT Medical Card",
  "criterion_hazmat_help": "Hazardous materials endorsement",
  "criterion_reefer_help": "Refrigerated trailer experience",
  "criterion_endorsements_help": "Comma-separated, for example Tanker, Doubles",
  "vacancy_criteria_footer": "Criteria are applied automatically to every new public application.",
  "vacancy_share_heading": "Share vacancy",
  "vacancy_share_description": "Send the link to a driver or place the QR code on printed materials.",
  "vacancy_public_link": "Public link",
  "vacancy_copy_link": "Copy link",
  "vacancy_scan_qr": "Or scan the QR code",
  "vacancy_qr_alt": "Public application QR code",
  "vacancy_open_public": "Open public application",
  "vacancy_share_inactive": "The public link is not active yet",
  "vacancy_share_activate": "Set the vacancy to Active to start accepting applications.",
  "vacancy_manage_application": "Configure public application",
  "qualification_reason_cdl_class": "CDL-{actual}; CDL-{required} is required.",
  "qualification_reason_hazmat": "The required Hazmat endorsement is missing.",
  "qualification_reason_reefer": "Reefer experience is below the required {months} months.",
  "qualification_has_contact": "Phone or email",
  "qualification_auto_heading": "Auto-qualification result",
  "qualification_system_approved": "System approved the candidate",
  "qualification_system_rejected": "System rejected the candidate",
  "qualification_system_review": "Manual review required",
  "qualification_match_heading": "Criteria match",
  "qualification_override": "Override decision",
  "qualification_override_reason": "Reason for changing the decision",
  "qualification_override_hint": "This comment will be permanently saved in the audit log.",
  "qualification_save_decision": "Save decision",
  "qualification_actual": "Actual",
  "qualification_required": "Required",
  "qualification_rule_hazmat_required": "Hazmat endorsement",
  "qualification_rule_reefer_experience_months": "Reefer experience",
  "qualification_rule_contact": "Contact details",
  "view_not_specified": "Not specified",
  "company_edit_profile": "Edit company profile",
  "company_information_hint": "Identity, public contacts and operating scale.",
  "company_regulatory_identifiers": "Regulatory identifiers",
  "company_regulatory_hint": "USDOT and MC identifiers used for compliance.",
  "company_contact_address": "Contact & address",
  "company_contact_hint": "Primary company contact and registered address.",
  "company_edit_profile_hint": "Update only the fields that have changed.",
  "company_upload_logo": "Upload new logo",
  "profile_account_details": "Account details",
  "profile_account_details_hint": "Your identity and workspace assignment.",
  "profile_terminal": "Terminal",
  "profile_security": "Security",
  "profile_security_message": "Your password is securely protected.",
  "profile_password_last_changed": "Last changed",
  "settings_readonly_description": "Review configuration safely. Open a focused editor only when you need to make a change.",
  "settings_stage_regular": "Pipeline stage",
  "settings_edit_rules": "Edit rules",
  "settings_edit_risk": "Edit deductions",
  "settings_risk_event": "Risk event",
  "settings_risk_deduction": "Deduction",
  "settings_manage_dictionaries": "Manage dictionaries",
  "settings_edit_stage": "Edit stage",
  "vacancy_edit_all": "Edit all",
  "vacancy_compensation": "Compensation",
  "vacancy_compensation_hint": "Pay, bonuses and guaranteed earnings.",
  "vacancy_geography": "Geography",
  "vacancy_geography_hint": "Hiring area, routes and allowed states.",
  "candidate_employment_timeline_hint": "Work history is shown chronologically. Edit one employer at a time.",
  "spa_main_navigation": "Main navigation",
  "spa_open_navigation": "Open navigation",
  "spa_candidate": "Candidate",
  "spa_add_a_driver_profile": "Add a driver profile",
  "spa_vacancy": "Vacancy",
  "spa_open_a_new_position": "Open a new position",
  "spa_task": "Task",
  "spa_assign_the_next_action": "Assign the next action",
  "spa_schedule_a_conversation": "Schedule a conversation",
  "spa_close_navigation": "Close navigation",
  "spa_loading": "Loading",
  "spa_failed_to_load_data": "Failed to load data",
  "spa_retry": "Retry",
  "spa_request_failed": "Request failed",
  "spa_candidate_not_found": "Candidate not found",
  "spa_no_stage": "No stage",
  "spa_no_vacancy": "No vacancy",
  "spa_risk": " risk",
  "spa_profile_completeness": "% profile completeness ·",
  "spa_item_s_need_attention": "{count} item(s) need attention.",
  "spa_profile_sections": "Profile sections",
  "spa_contacts_and_assignment": "Contacts and assignment",
  "spa_class": "Class ",
  "spa_number_not_provided": "number not provided",
  "spa_cdl_expiry": "CDL expiry",
  "spa_medical_card_expiry": "Medical Card expiry",
  "spa_total_experience": "Total experience",
  "spa_months": " months",
  "spa_manual_transmission": "Manual transmission",
  "spa_next_candidate_actions": "Next candidate actions",
  "spa_scheduled_interview": "Scheduled interview",
  "spa_everything_is_under_control": "Everything is under control",
  "spa_no_urgent_tasks": "No urgent tasks",
  "spa_risk_factors": "Risk factors",
  "spa_no_risks_identified": "No risks identified",
  "spa_automatic_assessment_based_on_company_and_vacancy_rules": "Automatic assessment based on company and vacancy rules",
  "spa_calculating": "Calculating…",
  "spa_recalculate": "Recalculate",
  "spa_employment_history": "Employment history",
  "spa_employment_and_driving_experience_history": "Employment and driving experience history",
  "spa_present": "present",
  "spa_not_specified": "Not specified",
  "spa_reason_for_leaving": "Reason for leaving",
  "spa_no_employment_history_added": "No employment history added",
  "spa_add_the_candidates_previous_employers": "Add the candidate's previous employers.",
  "spa_incidents": "Incidents",
  "spa_no_incidents": "No incidents",
  "spa_interviews": "Interviews",
  "spa_no_interviews_scheduled_yet": "No interviews scheduled yet",
  "spa_uploaded": "Uploaded",
  "spa_no_documents_uploaded": "No documents uploaded",
  "spa_candidate_context_and_communication_history": "Candidate context and communication history",
  "spa_add_important_candidate_context": "Add important candidate context.",
  "spa_text": "Text",
  "spa_no_activity_yet": "No activity yet",
  "spa_actions_will_appear_here": "Actions will appear here.",
  "spa_primary_contacts_and_initial_vacancy_assignment": "Primary contacts and initial vacancy assignment.",
  "spa_unassigned": "Unassigned",
  "spa_cdl_class": "CDL class",
  "spa_experience_months": "Experience, months",
  "spa_create_candidate": "Create candidate",
  "spa_name_phone_email_cdl": "Name, phone, email, CDL",
  "spa_scroll_the_table_horizontally_to_see_all_columns": "Scroll the table horizontally to see all columns",
  "spa_no_contact_details": "No contact details",
  "spa_no_data": "No data",
  "spa_open": "Open ",
  "spa_no_matching_candidates_found": "No matching candidates found",
  "spa_in_person": "In person",
  "spa_good_afternoon": "Good afternoon",
  "spa_period": "Period",
  "spa_key_metrics": "Key metrics",
  "spa_show_all": "Show all (",
  "spa_select_a_file": "Select a file",
  "spa_pdf_images_word_and_text_files_up_to_20_mb_are_supported": "PDF, images, Word and text files up to 20 MB are supported.",
  "spa_select": "Select",
  "spa_valid_until": "Valid until",
  "spa_upload": "Upload",
  "spa_manage_document_uploads_reviews_and_expiration_dates": "Manage document uploads, reviews and expiration dates.",
  "spa_all_types": "All types",
  "spa_expires": "Expires",
  "spa_uploaded_by": "Uploaded by",
  "spa_status": "Status ",
  "spa_upload_documents_from_the_candidate_profile_or_change_the_filters": "Upload documents from the candidate profile or change the filters.",
  "spa_new_interview": "New interview",
  "spa_schedule_a_conversation_with_the_candidate": "Schedule a conversation with the candidate.",
  "spa_interviewer": "Interviewer",
  "spa_duration_min": "Duration, min.",
  "spa_link_or_location": "Link or location",
  "spa_schedule": "Schedule",
  "spa_plan_conversations_record_outcomes_and_manage_the_schedule": "Plan conversations, record outcomes and manage the schedule.",
  "spa_list": "List",
  "spa_day": "Day",
  "spa_week": "Week",
  "spa_month": "Month",
  "spa_min": "min.",
  "spa_no_interviews_found": "No interviews found",
  "spa_schedule_the_first_meeting_or_change_the_filters": "Schedule the first meeting or change the filters.",
  "spa_mon": "Mon",
  "spa_tue": "Tue",
  "spa_wed": "Wed",
  "spa_thu": "Thu",
  "spa_fri": "Fri",
  "spa_sat": "Sat",
  "spa_sun": "Sun",
  "spa_move": "Move ",
  "spa_driverflow_home": "DriverFlow — home",
  "spa_signing_in": "Signing in…",
  "spa_driverflow_capabilities": "DriverFlow capabilities",
  "spa_team_roles_and_access": "Team, roles and access.",
  "spa_organization_details_and_terminals": "Organization details and terminals.",
  "spa_pipeline_stages_and_assessment_rules": "Pipeline stages and assessment rules.",
  "spa_events_that_need_attention": "Events that need attention.",
  "spa_activity_log": "Activity log",
  "spa_history_of_changes_and_security_events": "History of changes and security events.",
  "spa_your_account_settings": "Your account settings.",
  "spa_companies_and_platform_status": "Companies and platform status.",
  "spa_fleet": "Fleet",
  "spa_no_employees": "No employees",
  "spa_fleet_size": "Fleet size",
  "spa_legal_name_is_not_provided": "Legal name is not provided",
  "spa_company_details": "Company details",
  "spa_primary_legal_and_contact_information": "Primary legal and contact information",
  "spa_terminals": "Terminals",
  "spa_company_operating_locations": "Company operating locations",
  "spa_enter_a_name": "Enter a name",
  "spa_enter_a_hex_color": "Enter a HEX color",
  "spa_pipeline_stages": "Pipeline stages",
  "spa_order_color_and_final_hiring_states": "Order, color and final hiring states",
  "spa_position": "Position",
  "spa_final_stage": " · Final stage",
  "spa_add_stage": "Add stage",
  "spa_the_new_stage_will_appear_at_the_end_of_the_pipeline": "The new stage will appear at the end of the pipeline",
  "spa_no_notifications": "No notifications",
  "spa_new_events_will_appear_here": "New events will appear here.",
  "spa_time": "Time",
  "spa_entity": "Entity",
  "spa_the_log_is_empty": "The log is empty",
  "spa_enter_your_current_password": "Enter your current password",
  "spa_at_least_8_characters": "At least 8 characters",
  "spa_driverflow_account": "DriverFlow account",
  "spa_security_and_personal_settings": "Security and personal settings",
  "spa_use_a_unique_password_with_at_least_8_characters": "Use a unique password with at least 8 characters.",
  "spa_password_updated": "Password updated.",
  "spa_save_password": "Save password",
  "spa_server_session": "Server session",
  "spa_sign_in_is_protected_by_a_session_token_and_bcrypt": "Sign-in is protected by a session token and bcrypt.",
  "spa_use_the_new_credentials_the_next_time_you_sign_in_after_changing_the_pas": "Use the new credentials the next time you sign in after changing the password.",
  "spa_analyze_the_pipeline_conversion_and_team_performance": "Analyze the pipeline, conversion and team performance.",
  "spa_report_period": "Report period",
  "spa_365_days": "365 days",
  "spa_export_pipeline": "Export pipeline",
  "spa_candidate_distribution_by_stage": "Candidate distribution by stage",
  "spa_candidates_in_progress": "Candidates in progress",
  "spa_team_share": "Team share",
  "spa_pipeline_share": "Pipeline share",
  "spa_volume": "Volume",
  "spa_new_task": "New task",
  "spa_assign_an_owner_and_due_date": "Assign an owner and due date.",
  "spa_no_candidate": "No candidate",
  "spa_manage_recruiter_actions_deadlines_and_team_accountability": "Manage recruiter actions, deadlines and team accountability.",
  "spa_all_assignees": "All assignees",
  "spa_overdue": "Overdue",
  "spa_no_tasks_found": "No tasks found",
  "spa_create_a_position_and_publish_it_after_completing_the_requirements": "Create a position and publish it after completing the requirements.",
  "spa_search_vacancies": "Search vacancies",
  "spa_vacancy_status": "Vacancy status",
  "spa_drivers_needed": "Drivers needed",
  "spa_target_date": "Target date",
  "spa_no_description_provided": "No description provided",
  "spa_duplicate": "Duplicate ",
  "spa_vacancy_unavailable": "Vacancy unavailable",
  "spa_check_the_link": "Check the link",
  "spa_per_mile": " per mile",
  "spa_per_week": " per week",
  "spa_competitive_pay": "Competitive pay",
  "spa_routes_across_48_states": "Routes across 48 states",
  "spa_enter_a_phone_number": "Enter a phone number",
  "spa_consistent_miles_and_a_predictable_schedule": "Consistent miles and a predictable schedule.",
  "spa_consistent_weekly_mileage": "Consistent weekly mileage",
  "spa_green_truck_on_an_open_highway": "Green truck on an open highway",
  "spa_apply_now": "Apply now",
  "spa_it_takes_about_4_minutes": "It takes about 4 minutes",
  "spa_your_data_is_protected": "Your data is protected.",
  "spa_save_and_exit": "Save and exit",
  "spa_step": "Step",
  "spa_of_4": "of 4",
  "spa_license": "License",
  "spa_history": "History",
  "spa_check_the_required_fields": "Check the required fields.",
  "spa_lets_connect": "Let's connect",
  "spa_tell_us_how_a_recruiter_can_reach_you": "Tell us how a recruiter can reach you.",
  "spa_mobile_phone": "Mobile phone",
  "spa_we_use_this_information_only_for_your_application": "We use this information only for your application.",
  "spa_your_license": "Your license",
  "spa_enter_your_commercial_license_class_and_experience": "Enter your commercial license class and experience.",
  "spa_issuing_state": "Issuing state",
  "spa_select_a_state": "Select a state",
  "spa_commercial_driving_experience": "Commercial driving experience",
  "spa_up_to_6_months": "Up to 6 months",
  "spa_1_2_years": "1–2 years",
  "spa_3_years": "3+ years",
  "spa_safety_history": "Safety history",
  "spa_tell_us_about_the_past_three_years": "Tell us about the past three years.",
  "spa_how_many_preventable_accidents": "How many preventable accidents?",
  "spa_how_many_traffic_violations": "How many traffic violations?",
  "spa_honest_answers_help_us_find_the_right_vacancy_for_you": "Honest answers help us find the right vacancy for you.",
  "spa_add_documents": "Add documents",
  "spa_take_photos_of_your_documents_or_choose_a_file_you_can_also_do_this_late": "Take photos of your documents or choose a file. You can also do this later with a recruiter.",
  "spa_cdl_photo": "CDL photo",
  "spa_front_side_clear_image": "Front side, clear image",
  "spa_choose_file": "Choose file",
  "spa_medical_card_photo": "Medical Card photo",
  "spa_the_expiration_date_must_be_visible": "The expiration date must be visible",
  "spa_i_confirm_that_the_information_in_this_application_is_accurate": "I confirm that the information in this application is accurate.",
  "spa_continue": "Continue",
  "spa_submitting": "Submitting…",
  "spa_submit_application": "Submit application",
  "spa_saved_automatically": "Saved automatically",
  "spa_application_received": "Application received",
  "spa_our_recruiting_team_will_review_your_information_and_contact_you_soon": "Our recruiting team will review your information and contact you soon.",
  "spa_recruiting_team": "Recruiting team",
  "spa_source_examples": "Referral, Website…",
  "risk_missing_documents_prefix": "Missing documents:",
  "validation_email_required": "Enter an email address",
  "validation_password_required": "Enter a password",
  "validation_first_name_required": "Enter a first name",
  "validation_last_name_required": "Enter a last name",
  "validation_title_required": "Enter a name",
  "validation_source_name_required": "Enter a channel or placement name",
  "api_vacancy_not_found": "Vacancy not found",
  "api_source_not_found": "Tracking source not found",
  "api_vacancy_close_action_required": "Choose what to do with active candidates",
  "api_rejected_stage_missing": "Add a Rejected stage before rejecting candidates",
  "api_enter_note": "Enter a note",
  "api_enter_company_name": "Enter a company name",
  "api_enter_terminal_name": "Enter a terminal name",
  "api_enter_stage_name": "Enter a stage name",
  "api_enter_employer": "Enter an employer",
  "api_internal_server_error": "Internal server error",
  "risk_factor_accident_history": "Accident history",
  "api_task_not_found": "Task not found",
  "api_interview_not_found": "Interview not found",
  "risk_factor_employment_history_missing": "Employment history is missing",
  "api_comment_required": "Comment is required",
  "api_company_blocked": "Company is blocked",
  "api_company_context_required": "Company context is not selected",
  "api_route_not_found": "Route not found",
  "risk_factor_medical_card_missing": "Medical Card is missing",
  "risk_factor_medical_card_expired": "Medical Card is expired",
  "api_invalid_credentials": "Invalid email or password",
  "risk_factor_insufficient_experience": "Insufficient experience",
  "api_invalid_identifier": "Invalid identifier",
  "api_invalid_path": "Invalid path",
  "api_invalid_status": "Invalid status",
  "api_stage_in_use": "Cannot delete a stage while candidates are assigned to it",
  "api_new_password_min_length": "New password must contain at least 8 characters",
  "api_validation_error": "Validation error",
  "api_check_not_found": "Check not found",
  "risk_factor_cdl_expired": "Driver's license is expired",
  "api_result_and_comment_required": "Result and comment are required",
  "api_employee_not_found": "Employee not found",
  "api_link_invalid_or_expired": "Link is invalid or expired",
  "api_current_password_incorrect": "Current password is incorrect",
  "api_authentication_required": "Authentication required",
  "api_incident_type_required": "Specify an incident type",
  "api_stage_not_found": "Stage not found",
  "campaign_step_driver_type": "1. Driver type & Route",
  "campaign_step_pay": "2. Pay & Hometime",
  "campaign_step_company": "3. Company & Radius",
  "campaign_step_states": "4. States & Qualification",
  "campaign_subtitle_desc": "Configure vacancy parameters to attract drivers",
  "campaign_title_placeholder": "e.g. OTR Class A Company Driver — Midwest Route",
  "campaign_hiring_types_title": "What type of drivers are you hiring?",
  "campaign_driver_company": "Company Driver (W-2)",
  "campaign_driver_company_sub": "W-2 employee",
  "campaign_driver_owner": "Owner Operator (1099)",
  "campaign_driver_owner_sub": "1099 / Own truck",
  "campaign_driver_lease": "Lease Purchase",
  "campaign_driver_lease_sub": "Path to ownership",
  "campaign_route_types_title": "Route type",
  "campaign_route_otr": "OTR (Over the Road)",
  "campaign_route_otr_sub": "Nationwide routes",
  "campaign_route_regional": "Regional",
  "campaign_route_regional_sub": "Multi-state region",
  "campaign_route_local": "Local",
  "campaign_route_local_sub": "Home daily",
  "campaign_trailer_types_title": "Trailer type / Position",
  "campaign_trailer_dry_van": "Dry Van",
  "campaign_trailer_flatbed": "Flatbed",
  "campaign_trailer_tanker": "Tanker",
  "campaign_trailer_team": "Team",
  "campaign_trailer_specialty": "Specialty",
  "campaign_trailer_other": "Other type",
  "campaign_pay_hometime_title": "Compensation & Schedule",
  "campaign_pay_hometime_sub": "Specify competitive pay terms and home time policy",
  "campaign_pay_driver_title": "Driver compensation",
  "campaign_pay_freq_annual": "Per year",
  "campaign_pay_freq_weekly": "Per week",
  "campaign_pay_freq_mile": "Per mile",
  "campaign_pay_range_toggle": "Specify pay range (min and max)",
  "campaign_pay_min": "Minimum, $",
  "campaign_pay_max": "Maximum, $",
  "campaign_pay_amount": "Amount, $",
  "campaign_pay_offer_badge": "Your offer",
  "campaign_pay_per_year": "year",
  "campaign_pay_per_week": "wk",
  "campaign_pay_per_mile": "mile",
  "campaign_hometime_title": "Hometime schedule",
  "campaign_hometime_sub": "Choose standard schedule or customize trip & rest duration",
  "campaign_ht_home_daily": "Home daily",
  "campaign_ht_weekly": "Weekly home",
  "campaign_ht_biweekly": "Every 2 weeks",
  "campaign_ht_2weeks_out": "2 weeks out",
  "campaign_ht_3weeks_out": "3 weeks out",
  "campaign_ht_monthly": "Monthly home",
  "campaign_hometime_out": "On the road:",
  "campaign_hometime_home": "Home:",
  "campaign_unit_weeks": "Weeks",
  "campaign_unit_days": "Days",
  "campaign_company_radius_title": "Company profile & Hiring radius",
  "campaign_company_radius_sub": "Specify company information and geographic reach",
  "campaign_company_name": "Company name",
  "campaign_truck_count": "Truck fleet size",
  "campaign_radius_title": "Driver hiring radius",
  "campaign_radius_50_120": "50–120 Miles",
  "campaign_radius_50_120_sub": "Local / Extended radius",
  "campaign_radius_states": "Full States",
  "campaign_radius_states_sub": "Hiring in selected states",
  "campaign_radius_national": "National",
  "campaign_radius_national_sub": "Nationwide hiring (48 states)",
  "campaign_select_states_title": "Select hiring states",
  "campaign_select_states_sub": "Click on states where you hire drivers",
  "campaign_add_regions_toggle": "Add hiring regions",
  "campaign_add_regions_sub": "Optionally specify broader US regions",
  "campaign_region_northeast": "Northeast",
  "campaign_region_southeast": "Southeast",
  "campaign_region_midwest": "Midwest",
  "campaign_region_south_central": "South Central",
  "campaign_region_southwest": "Southwest",
  "campaign_region_mountain_west": "Mountain West",
  "campaign_region_pacific_nw": "Pacific Northwest",
  "campaign_region_west_coast": "West Coast",
  "campaign_req_scoring_title": "Qualification requirements (Auto-screening)",
  "campaign_req_scoring_sub": "Candidates not meeting conditions will be auto-disqualified",
  "campaign_req_cdl": "CDL Class",
  "campaign_req_cdl_any": "Any class",
  "campaign_req_exp": "Min. experience",
  "campaign_req_exp_none": "No experience",
  "campaign_req_exp_6m": "6+ months",
  "campaign_req_exp_1y": "1+ year",
  "campaign_req_exp_2y": "2+ years",
  "campaign_req_exp_3y": "3+ years",
  "campaign_req_accidents": "Max. accidents",
  "campaign_req_acc_0": "0 accidents",
  "campaign_req_acc_1": "Up to 1 accident",
  "campaign_req_acc_2": "Up to 2 accidents",
  "campaign_req_violations": "Max. violations",
  "campaign_req_viol_0": "0 violations",
  "campaign_req_viol_1": "Up to 1 violation",
  "campaign_req_viol_2": "Up to 2 violations",
  "btn_next": "Next",
  "btn_back": "Back",
  "btn_create_vacancy": "Create vacancy",

  "hiring_cdl_class_fmt": "CDL Class {class}",
  "hiring_exp_fmt": "Min. experience {months} mo.",
  "hiring_max_accidents_fmt": "Max {count} accident(s)",
  "hiring_max_violations_fmt": "Max {count} violation(s)",
  "hiring_medical_required_active": "Valid DOT medical card",
  "hiring_endorsements_fmt": "Endorsements: {list}",
  "hiring_states_fmt": "States: {list}",

  "qual_auto_status_label": "Automated Qualification Status",
  "qual_verdict_qualified": "MEETS ALL CRITERIA",
  "qual_verdict_rejected": "DOES NOT MEET CRITERIA",
  "qual_verdict_review": "REQUIRES RECRUITER REVIEW",
  "qual_all_passed": "All specified vacancy criteria successfully passed by the driver.",
  "qual_discrepancies_found": "Identified criteria discrepancies:",

  "public_questions": "Questions",
  "public_additional_questions": "Additional Questions",
  "public_answer_questions_hint": "Please answer the questions for this vacancy",
  "spa_yes": "Yes",
  "spa_no": "No",
  "spa_select_option": "Select an option",

  "form_required_field": "required field",
  "auth_show_password": "Show password",
  "auth_hide_password": "Hide password",
  "auth_caps_lock": "Caps Lock is on",
  "session_expired_body": "Your session expired. Sign in again to continue.",
  "dashboard_good_morning": "Good morning",
  "dashboard_good_evening": "Good evening",
  "notifications_unread_suffix": "unread notifications",
  "upload_file_too_large": "The file exceeds 20 MB — pick a smaller file or compress the scan.",
  "upload_file_wrong_type": "This file type is not supported. Allowed: PDF, images, Word and text.",
  "upload_failed_toast": "Document upload failed",
  "upload_progress_label": "Uploading file… {percent}%",
  "document_delete_confirm_title": "Delete document?",
  "document_delete_confirm_body": "The file “{name}” and its record will be permanently removed.",
  "document_deleted_toast": "Document deleted",
  "interview_conflict_error": "This interviewer or candidate already has an interview at that time.",
  "interview_conflict": "This interviewer or candidate already has an interview at that time.",
  "interview_past_badge": "Past",
  "tasks_overdue_badge": "Overdue",
  "dialog_unsaved_title": "Close without saving?",
  "dialog_unsaved_body": "The information you entered will be lost.",
  "btn_keep_editing": "Keep editing",
  "management_self_lockout_error": "You cannot block yourself or revoke your own user-management permission.",
  "management_role_change_confirm_title": "Change the access level?",
  "management_role_change_confirm_body": "The switches you changed by hand will be replaced with the standard set for “{role}”.",
  "employee_saved_toast": "Employee saved",
  "profile_saved_reset_hint": "Draft changes",
  "reports_no_data": "No data for the selected period.",
  "reports_stale_period": "Showing the previous period — refreshing…",
  "hiring_applications_truncated": "Showing the first {shown} of {total} applications.",
  "btn_show_more": "Show more",
  "kanban_drop_anywhere": "Drag onto any column",

  "reset_invalid_heading": "This link is no longer valid",
  "reset_invalid_body": "The password-reset link has expired or was already used. Request a fresh one.",
  "reset_request_new": "Request a new link",
  "error_password_min_length_hint": "At least 8 characters",
  "forgot_sent_resend": "Send the email again",
  "spa_file": "File",
  "spa_6_to_12_months": "6–12 months",
  "spa_2_to_4_years": "2–4 years",
  "spa_5_plus_years": "5+ years",
  "api_too_many_attempts": "Too many sign-in attempts. Try again in 15 minutes.",
  "candidate_delete_confirm_title": "Delete candidate?",
  "candidate_delete_confirm_body": "“{name}”, along with all interviews, tasks, notes and uploaded documents, will be permanently removed. This cannot be undone.",
  "toast_candidate_deleted": "Candidate deleted",
  "dash_period_aria": "Reporting period",
  "dash_kpi_vs_prev": "vs prev. {days} d.",
  "dash_kpi_open_need": "drivers still needed",
  "dash_kpi_next_interview": "next: {when}",
  "dash_when_today": "today",
  "dash_when_tomorrow": "tomorrow",
  "dash_chart_activity": "Candidate activity",
  "dash_chart_activity_sub": "New drivers added, by day",
  "dash_chart_sources": "Application sources",
  "dash_chart_sources_sub": "Where the last {days} days came from",
  "dash_funnel_title": "Stage funnel",
  "dash_funnel_sub": "All candidates by pipeline stage",
  "dash_compliance_title": "Compliance health",
  "dash_compliance_sub": "Driver document status across the pipeline",
  "dash_share_of_total": "{percent}%",
  "dash_nothing_pending": "Nothing pending",
  "dash_all_clear": "No overdue tasks or expiring documents.",
  "dash_donut_total": "total"
};
const reverse = (dictionary: Record<string, string>) => {
    const result = new Map<string, string>();
    for (const [key, value] of Object.entries(dictionary))
        if (!result.has(value))
            result.set(value, key);
    return result;
};
const reverseEnglish = reverse(enTranslations);
const messageKeys: Record<string, string> = {
    "CDL information is missing": "qualification_reason_missing_cdl",
    "Medical Card information is missing": "qualification_reason_missing_medical",
    "Medical Card is expired": "qualification_reason_expired_medical",
    "Home state is missing": "qualification_reason_missing_state",
};
export const dateLocale = () => "en-US";
export function t(source: string, params?: Record<string, string | number>): string {
    if (!source)
        return source;
    const leading = source.match(/^\s*/)?.[0] ?? "";
    const trailing = source.match(/\s*$/)?.[0] ?? "";
    const text = source.trim();
    if (!text)
        return source;
    const experience = text.match(/^Experience is below the required (\d+) months$/);
    if (experience)
        return t("qualification_reason_experience", { months: experience[1] });
    // Screening reasons arrive from the server as built English sentences, so
    // each shape is matched back to a key before interpolation.
    const experienceBelow = text.match(/^Experience \((\d+) mos\) is below required (\d+) months$/);
    if (experienceBelow)
        return t("qualification_reason_experience_below", { actual: experienceBelow[1], required: experienceBelow[2] });
    const cdlClass = text.match(/^CDL class (\S+) is required \(candidate has ([^)]+)\)$/);
    if (cdlClass)
        return t("qualification_reason_cdl_class_mismatch", { required: cdlClass[1], actual: cdlClass[2] });
    const accidents = text.match(/^Accidents count \((.+?)\) exceeds maximum allowed \((\d+)\)$/);
    if (accidents)
        return t("qualification_reason_accidents_over", { actual: accidents[1], max: accidents[2] });
    const violations = text.match(/^Violations count \((.+?)\) exceeds maximum allowed \((\d+)\)$/);
    if (violations)
        return t("qualification_reason_violations_over", { actual: violations[1], max: violations[2] });
    const endorsements = text.match(/^Missing endorsements: (.+)$/);
    if (endorsements)
        return t("qualification_reason_endorsements", { endorsements: endorsements[1] });
    if (/^State \S+ is outside the allowed hiring area$/.test(text))
        return t("qualification_reason_state");
    const missingDocumentsToken = "risk_missing_documents:";
    if (text.startsWith(missingDocumentsToken))
        return `${t("risk_missing_documents_prefix")} ${text.slice(missingDocumentsToken.length).split(",").map((item) => t(item.trim())).join(", ")}`;
    const directKey = Object.hasOwn(enTranslations, text) ? text : messageKeys[text];
    const key = directKey ?? reverseEnglish.get(text);
    let translated = key ? enTranslations[key] : undefined;
    if (!translated)
        translated = text;
    if (params) {
        for (const [name, value] of Object.entries(params))
            translated = translated.replaceAll(`{${name}}`, String(value));
    }
    return `${leading}${translated}${trailing}`;
}
/** English plural without machine-style "(s)" placeholders. */
export function pluralN(count: number, forms: [singular: string, plural: string]): string {
    return `${count} ${count === 1 ? forms[0] : forms[1]}`;
}
